import { Component, OnInit, ViewChild, ViewChildren, QueryList, ElementRef, Inject, HostListener } from '@angular/core';
import { UserDataService } from '../../services/user-data.service';
import { TabView } from 'primeng/tabview';
import { GroupAdminDetails } from '../../model/group-admin/groupAdminDetails';
import { GroupAdminService } from "../../services/group-admin/group-admin.service";
import { ExpTinyComponent } from '../../common/component/exp-tiny/exp-tiny.component';
import { HeirarchyData } from "../../model/LoginUserInfo/HeirarchyData";
import { QmaConstant } from "../../constant/qma-constant";
import { AgGridCheckboxComponent } from '../user/ag-grid-checkbox.component';
import { OverlayPanel } from "primeng/overlaypanel";
import { SaveInquiryRules } from '../../model/group-admin/saveInquiryRules';
import { GroupInquiryCriteriaList } from '../../model/group-admin/groupInquiryCriteriaList';
import { GroupInquiryActions } from '../../model/group-admin/groupInquiryActions';
import { MessageService } from 'primeng/api';
import { ColorPickerComponent } from '../user/color-picker.component';
import { DomSanitizer } from '@angular/platform-browser';
import { DOCUMENT } from "@angular/common";
import { ExcelService, ExcelExport, InqRulesReorderInfo } from "../../services/common/excel.service";
import { CheckboxListComponent } from '../../common/component/checkbox-list/checkbox-list.component';
import { UserEntitlementCheckboxComponent } from '../user/user-entitlement-checkbox.component';
import { UserEntitlementAddCheckboxComponent } from '../user/user-entitlement-add-checkbox.component';
import { ClientCategory } from "../../model/LoginUserInfo/clientCategory";
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import { Module } from "@ag-grid-community/core";
import { InquiryOrderComponent } from '../user/inquiry-order-component';
import * as _ from "lodash";
import  $ from 'jquery';
import { RightNavigationService } from '../../services/panel/panel.service';
import {forkJoin, Subscription} from 'rxjs';
import { SessionTimeOut } from '../../services/sessiontimeout.service';
import { SuperAdminSetupService } from '../../services/super-admin-setup/super-admin-setup.service';
import { LoggingService } from '../../services/global-error/logging.service';
import { AppUtils } from '../../common/utility/appUtil';
import { GlobalDirectoryService } from '../../services/global-directory/global-directory.service';
import {TabDataService} from "../../services/tab-data.service";
import {CustomTextFilterComponent} from "../../inbox/inboxView/custom-text-filter/custom-text-filter.component";
import {CustomCheckboxFilterComponent} from "../../inbox/inboxView/custom-checkbox-filter/custom-checkbox-filter.component";
import { AgPrimedropdownEditorComponent } from '../ag-primedropdown-editor/ag-primedropdown-editor.component';

@Component({
  selector: 'app-group-admin',
  templateUrl: './group-admin.component.html',
  styleUrl: './group-admin.component.scss'
})
export class GroupAdminComponent implements OnInit {
  testLoad:boolean = false;
  isDropdownOpen: boolean = false;
  autoResponseEdit: boolean = false;
  isDragOver: boolean = false;
  isSuccess: boolean = true;
  isDownloadOpen: boolean = false;
  isExpanded: boolean = true;
  metadataBackup: any = [];
  routeListBackup: any = [];
  modules: Module[] = [ClientSideRowModelModule];
  showSpinner: boolean = false;
  ClientNameValidation: string = '';
  showGroupName: boolean = false;
  gridRoleApi: any;
  bulkUploadData: any = [];
  uploadData: any = [];
  errAndSuccess: string = "";
  closeFlagBulkUpload: boolean;
  errorUpload: boolean = false;
  selectedFormat: string = "CSV";
  domainMsg: string = "";
  entitleListBackup: any = [];
  errorMessageForGroupAdmin: string;
  inqprocessingRegionList: any = [];
  inqTagsList: any = [];
  inqRequestTypeList: any = [];
  requestTypes = [];
  displayProfile: boolean = false;
  editorFlagProfile: boolean = false;
  display: boolean = false;
  profileFlag: boolean = false;
  editorFlag: boolean = false;
  fromAdminAutoResponse: boolean = false;
  domainValidationFlag: boolean = false;
  inquirySourceList = [];
  metadataTypeList: any = [];
  selectedGroupList = [];
  public metaRowData: any;
  public addNewUserData: any = [];
  public addNewUserColumns;
  public newUserSoeid: string = '';
  public addNewUsercolumnDefs: any;
  newUserGridFlag: boolean = true;
  public entitleData: any;
  public entitleColumns;
  public metaColumnDefs;
  public pinnedTopRowData;
  public pinnedBottomRowData;
  public clientCategoryColumnDefs: any = [];
  public clientCategoryRowData: any = [];
  requestTypeList = [];
  rootCauseList = [];
  tagsList = [];
  originalTagList = [];
  processingRegionList = [];
  metaDataType = 'RequestTypes';
  isProcessingRegionMandatory: boolean = false;
  isTagMandatory: boolean = false;
  isRootCauseMandatory: boolean = false;
  isRootCauseMandatoryWOReply: boolean = false;
  private isGridReady = false;
  private initialPaginationDone = false;
  isRootCauseMandatoryAlways: boolean = true;
  dropdownChangeRequest: any = [];
  reqList: any = [];
  metaDeleteFlag: boolean = true;
  categoryDeleteFlag: boolean = true;
  domainDeleteFlag: boolean = true;
  metadataRecords: number = 0;
  categoryRecords: number = 0;
  domainRecords: number = 0;
  entitlementView: boolean = false;
  tabArray: Array<boolean> = [false, true];
  successFlag: boolean = false;
  closeFlag: boolean = false;
  closeFlagAddGroup: boolean = false;
  isExist: boolean = false;
  isGroupAdmin: boolean = false;
  metaTagValidationFlag: boolean = false;
  selectedCustomClientList: any = [];
  grpSaveMsg: string = "";
  userEntitlementFlag: boolean = false;
  entitlementValidationMsg: string = "";
  formatOpenSubscription:Subscription;
  isFormatOpen: boolean = true;
  showPopUpDelete: boolean = false;
  confirmMsgText: string;
  groupTab: string;
  restoreHideFlag: boolean = false;
  defaultAutoResponse: string = `
<p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 1rem; color: #7e819b; font-family: OpenSans; font-size: 14px; padding-top: 2em; padding-bottom: 0.5em;">
  Thank you for your email. Your mail has been assigned to&nbsp;
  <span style="box-sizing: border-box; font-weight: bolder;">[user_firstname user_lastname]</span>&nbsp;for resolution.&nbsp;
  <span style="box-sizing: border-box; font-weight: bolder;">[user_firstname]</span>&nbsp;can be contacted on&nbsp;
  <span style="box-sizing: border-box; font-weight: bolder;">[user_contact_number]</span>.
  If escalation is required, the manager's contact details are:
</p>

<p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 1rem; color: #7e819b; font-family: OpenSans; font-size: 14px; font-weight: bold;">
  [manager_name]<br style="box-sizing: border-box;" />
  [manager_phone_number]<br style="box-sizing: border-box;" />
  [manager_email_address]
</p>

<p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 1rem; color: #7e819b; font-family: OpenSans; font-size: 14px;">
  We will provide a response to your query as soon as possible.
</p>
`;


  public groupManager: string = '';
  //  Icon Messages in admin
  public infoGroup: string = 'This section displays allows you to select the group to see and edit group details.';
  public infoEntitlement: string = 'Displays the current Group Entitlement details. Users can be added/removed from their entitlements.';
  public infoMetadata: string = 'Displays the current Group DL\'s inquiry related details. <strong>Request types</strong>, <strong>Root Cause Tags</strong> and <strong>Processing Region</strong> can be added/edited in this section.';
  public infoPreferences: string = 'Group Preferences can be enabled or disabled for the selected Group.';
  public infoPeerReview: string = 'Peer Review Domains can be added/removed from their respective group.Some valid domain names are XXXX';
  public infoEmailDisclaimer: string = 'Disclaimers to be shown for the group can be added here';
  public infoAutoResponse: string = 'Automated response for the group can be configured here.';
  public infoInquiryRules: string = 'Inquiry Rules for the group can be configured here.'
  public infoInquiryRulesExtTitle: string = 'Mark as Non-Inquiry:';
  public infoInquiryRulesExt: string = 'This option will route all incoming emails that match the rule criteria into a separate bucket.'
    + ' All such inquiries will be systematically resolved at the end of the business day.';
  public ruleDisclaimer: string = '>> Rules are displayed and processed by system in the order provided below. Rules are applied from top to bottom. Once rule matches an inquiry no other rules will be processed/applied. Re-ordering of the rules is currently unavailable.';
  public infoEsclaition: string = 'Group level escalation criteria can be configured here.';
  public infoClientCat: string = 'This section allows the user to define the custom client category.';
  public errorMessageForClientCategory: string = 'Maximum two custom categories allowed. Please delete any existing to create new.';
  public errorMessageForMetadata: string = "";
  public userAddGroupMsg: string = "";
  public concurrentUpdateMsg: string = "Your group's preferences have been updated by another user. \nPlease refresh your screen to get latest updates and make your changes again. \nThe changes that you’ve just made will not be saved.";
  public userSavedSuccess: string = 'Group Details saved successfully!';

  heirarchyData: HeirarchyData;
  version: number;
  gfcid: any = [];
  subjectEscalationList: any = [];

  public clientCategoryDataGridApi;
  public clientCategoryDataGridColumnApi;

  public metaDataGridApi;
  public metaDataGridColumnApi;
  public gridApi;
  public gridColumnApi;
  public addNewUserGridApi;
  public addNewUserGridColumnApi;
  public disablePaginationNextLast: boolean = false;
  public disablePaginationPrevFirst: boolean = false;
  public disablePaginationNextLastEntitlement: boolean = false;
  public disablePaginationPrevFirstEntitlement: boolean = false;
  selectedGroup: any = {};
  selectedAdminGroupName: string = "";

  @ViewChild('adminTabs', { static: true }) adminTabs: TabView;
  @ViewChild('entitlementUser') entitlementUser: ElementRef;
  @ViewChild('uploadFiles') uploadFiles: ElementRef;
  @ViewChild('duplicate', { static: true }) overlaypanel: OverlayPanel;
  @ViewChildren(ExpTinyComponent) editorList: QueryList<ExpTinyComponent>;
  @ViewChildren(CheckboxListComponent) checkboxListComponent: any;
  @ViewChild('restoreRules') restoreRulesPanel: OverlayPanel;
  @ViewChild('duplicate') duplicatePanel: OverlayPanel;

  // upload inquiry
  @ViewChild('uploadFilesForInquiry') uploadFilesForInquiry: ElementRef;
  public entitleGridApi;
  public entitleGridColumnApi;
  public entitleColDef;
  public metaCheckbox;
  public domainCheckbox;
  rowSelection;
  entitleSelUser: number = 0;
  entitleDelAndGropFlag: boolean = true;
  entitleAddUserDelAndGropFlag: boolean = true;
  entitlementInfo:boolean=false;
  finAnaArr = [];
  finPeerRevArr = [];
  finSupArr = [];
  finGrpAdmArr = [];
  public lbTotalRecords: number = 0;
  public lbPageSize: number = 0;
  public lbCurrentPage: number = 0;
  public lbTotalPages: number = 0;

  public lbTotalRecordsEntitlement: number = 0;
  public lbPageSizeEntitlement: number = 0;
  public lbCurrentPageEntitlement: number = 0;
  public lbTotalPagesEntitlement: number = 0;

  // Peer Review Domain
  public prdColumn;
  public prdData: any = [];
  validationFlag: boolean = false;
  enableAutCliAck: boolean = false;
  isAutoResponseEnabledForInternalDomain: boolean = false;
  includeAssignedUserInfo: boolean = false;
  includeUserContactInfo: boolean = false;
  includeManagerContactInfo: boolean = false;
  autoResFlagUI: boolean = false;
  autoResFlagDetails: boolean = true;
  //  Preferences
  makerCheckerRqd: boolean = false;
  attachmentBasedMakerChecker: boolean = false;
  predictiveRecipients: boolean = false;
  enableAutoAssignment: boolean = false;
  enableAutoReplySuggestion: boolean = false;
  isAutoAssignmentRollOutOrgs: boolean = false;
  isEmailSharingBlocked: boolean = false;
  isInquirySourceMandatory: boolean = false;
  isGfidMandatory: boolean = false;
  isInqReferenceIdReq: boolean = false;
  excludeMyGroupWhileReplyAll: boolean = false;

  // Enable/disable client contact list visibility for group members
  hideClientList: boolean = false;
  //  Enable/disable flag for Re-age need supervisor approval
  supervisiorApprovalForReage: boolean = false;

  // Request Type and Root Cause Linking
  requestTypeRootCauseFilter: boolean = false;

  holidayAndShiftDetails: boolean = false;
  isInquirySubStatusEnabledByOrgAdmin: boolean = false;
  enableWorkShiftDiv: boolean = true;
  enablePeerReviewDiv: boolean = true;
  peerRevDomain: string = 'All';
  selectedEntGrpName: any = [];
  entGrpName: any = [];
  selectedWeekelyOff: any = [];

  weekelyOff: any[];
  countryList: any[] = [];
  timeZones: any[] = [];
  selectedCountry: object = {};
  selectedTimeZone: object = {};
  shifttimeList: any[] = [{ "value": "00:00" }, { "value": "00:30" },
  { "value": "01:00" }, { "value": "01:30" }
    , { "value": "02:00" }, { "value": "02:30" }, { "value": "03:00" }, { "value": "03:30" }
    , { "value": "04:00" }, { "value": "04:30" }, { "value": "05:00" }, { "value": "05:30" }
    , { "value": "06:00" }, { "value": "06:30" }, { "value": "07:00" }, { "value": "07:30" }
    , { "value": "08:00" }, { "value": "08:30" }, { "value": "09:00" }, { "value": "09:30" }
    , { "value": "10:00" }, { "value": "10:30" }, { "value": "11:00" }, { "value": "11:30" }
    , { "value": "12:00" }, { "value": "12:30" }, { "value": "13:00" }, { "value": "13:30" }
    , { "value": "14:00" }, { "value": "14:30" }, { "value": "15:00" }, { "value": "15:30" }
    , { "value": "16:00" }, { "value": "16:30" }, { "value": "17:00" }, { "value": "17:30" }
    , { "value": "18:00" }, { "value": "18:30" }, { "value": "19:00" }, { "value": "19:30" }
    , { "value": "20:00" }, { "value": "20:30" }, { "value": "21:00" }, { "value": "21:30" }
    , { "value": "22:00" }, { "value": "22:30" }, { "value": "23:00" }, { "value": "23:30" }];
  selectedStartTime: object = {};
  selectedEndTime: object = {};
  //  end Preferences

  //  email disc
  emailDisc: string = '';

  //  auto response
  autoResponse: string = '';

  //  Escl criteria
  converThreshold: number;
  resTimeThreHr: number;
  resTimeThreMin: number;
  penApprThreHr: number;
  penApprThreMin: number;

  public columnDefs;
  public defaultColDef;

  public loginInfoResponse: any;
  //  inquiry rules
  public routesList: any = [];
  public routesColumn: any = [];
  entitleDataUserName: any = [];
  public gridApiInquiry;
  public gridColumnApiInquiry;
  public inquiryFlag = 0;
  public filterIconHide: boolean = false;
  public filterIconHideHorizontal: boolean = false;
  public filterText = "";
  public validationCheck: boolean = true;
  public validationCheckForAction: boolean = true;
  public validationCheckForEmpty: boolean = true;
  public validationRules;
  public inquiryRulesChecbox;
  public rulesDeleteFlag: boolean = true;
  public lastLogin: any;
  displaySuccess: boolean = false;
  displayError: boolean = false;
  errorMessage: boolean = false;
  inquireSaveButtonFlag: boolean = true;

  // metaTagValidationFlag: boolean = false;
  metaTagValidationMsg: string = "";

  //  Flag to check if user have group role.
  hasGroupRole: boolean = true;

  // Show QMA Admin only if configure Admin Role is not null
  isQMAAdmin: boolean = false;
  parser: any;

  // to show client category and its color code in custom client category
  clientCategories: ClientCategory[] = [];

  // Inquiry Rules Upload rules - Required to validate the values
  groupRequestTypes = [];
  groupProcessingRegion = [];
  groupTags = [];
  groupUsers = [];
  invalidRowMessage = [];
  uploadedValidInqRules = [];

  // Message attributes
  inquiryRulesUpload: boolean = false;
  inquiryRulesMsgTitle: string = '';
  inquiryRulesMsg: string = '';
  inquiryRulesConfirm: boolean = false;
  inquiryRulesRejected: boolean = false;
  duplicateColumn: any = [];
  duplicateList: any = [];
  duplicateCheckBox: any;

  // BCC Group Inquiry Rules
  isBccGrpSelected = false;
  inqAssignedGroups: any = [];
  groupSetupBoolean: boolean = false;

  //  Meta data type value.
  selectedMetaDataType: string = 'RequestTypes';
  start_typing_placehoder: string = "Start typing";

  // Restore button implemention for the rules screen
  restoreInquiryDate: Date;
  restoreStatus: boolean = false;

  //  Flag to display User Admin
  displayUserAdmin: boolean = false;
  displaySendUserNotification: boolean = false;

  activeMenuArray: Array<boolean> = [false, true, false, false, false, false, false, false];
  hideSubMenu: boolean = false;
  newMsgIndexes: number[] = [];

  displayDatabaseAdmin: boolean = false;

  // A pop-up blocks user to create request types
  workshiftErrMsg: string = "";

  // Admin Screen entitilements
  isUserAdmin: boolean = false;
  isGrpSetupAdmin: boolean = false;
  isMgmtHierarchyAdmin: boolean = false;
  isDBAdmin: boolean = false;
  canSendNotification: boolean = false;
  //mailbox dl mapping onboarding
  isMailBoxDLMapping: boolean = false;
  isMailBoxDLMappingPopup: boolean = false;
  // userGroup assignment
  isUserGroupAssignment: boolean = false;
  isUserGroupAssignmentPopup: boolean = false;
  displayAdminSetupPopup: boolean = false;


  //  Variables for Request type and Root Cause mapping
  reqTypeRootCauseMap: any[] = [];
  updatedReqTypeCauseMap: any[] = [];
  groupRootCauses: any[] = [];
  isSuperUser: boolean = true;
  displayAdminSetup: boolean = false;
  //sesion time out
  sessionAlertPopup: boolean = false;
  // for super admin
  displaySuperAdminSetup: boolean = false;
  isSuperAdminRole: boolean = false;
  isProdSupport: boolean = false;

  // for enable org metadata in hard code data point
  enableOrgMetaData: boolean = false;
  displayEnableOrgMetaDataOption: boolean = false;
  orgData: any = [];
  disableGroupMetadataAddOption: boolean = false;
  selectedOrgMetaDataType: any;
  orgName: any;
  disableAddMetaDataOption: boolean = false;
  autoAssignmentRollOutOrgsList: any[] = [];
  // it will true only when org level metadata is enable if org org level metdata is not enable then it
  displayOrgMetadata: boolean = false; // flag for display org level metadata in hard code data point
  blankStringValidationMsg: string = "UserId cannot be blank.";
  newUserSoeIdValidationFlag: boolean = false;
  enableInquirySubStatus: boolean;
  enableInquirySubStatusFlag: any;
  overrideCheckbox = false;
  isL6AndBelow = false;
  isManagerSelected: boolean;
  groupManagerID: any;
  groupManagerLevel: any;
  auId: string;
  contactInfoEndPoint: string;
  selectedL1: any;
  selectedL2: any;
  selectedL1UserId: any;
  selectedL2UserId: any;
  selectedBusinessSegment: any;
  isUserActiveGD: boolean;
  managedSegmentData: any = { 'msL6': null, 'psL5': '', 'psL6': '', 'psL7': '' };
  isLookupClicked = false;
  isSaved = true;

  groupOptions=[{title:'Group Details'},
    {title:'Metadata'},
    {title:'User Entitlements'},
    {title:'Preferences'},
    {title:'Bypass Peer Review'},
    {title:'Email Disclaimer'},
    {title:'Automated Response'},
    {title:'Inquiry Rules'},
    {title:'Escalation Criteria'},
    {title:'Client Category'},];

  selectedSendInquiry: any = null;
  sendInquirys: any[] = [{name: 'Group DL Name', key: 'groupName'}, {name: 'User Name', key: 'userName'}];

  activeGroupOption ='Group Details';
  peerReviewInfo:boolean=false;
  metadataInfo:boolean=false;
  emailDisclaimerlInfo:boolean=false;
  autoResponseInfo:boolean=false;

  private readonly SHOW_CLIENT_CATEGORY_MESSAGE_DELAY = 1000; // in milliseconds
  private readonly CLEAR_CLIENT_CATEGORY_MESSAGE_AFTER = 10000; // in milliseconds

  constructor(private userDataService: UserDataService, private groupAdminService: GroupAdminService, private tabService:TabDataService, private messageService: MessageService, private rightNavigationService: RightNavigationService, private sanatized: DomSanitizer, @Inject(DOCUMENT) private document: any, private excelService: ExcelService,
    private sessionTimeoutService: SessionTimeOut, private superAdminSetupSerivce: SuperAdminSetupService,
    private loggingService: LoggingService, private globalDirectoryService: GlobalDirectoryService) {

    this.subscribeSessionAlert();

    //  Starting function
    this.showInitial();
      
    //  Temporary show Last Login
    this.lastLogin = Date.now();

    this.parser = new DOMParser();
    this.rightNavigationService.getNavStatus().subscribe(clickedIndex => {
      // added this Nav status call to reset the chevron
      this.activeMenuArray[7] = false;
    });
  }

  showInitial() {
    this.entGrpName = [];
    this.reqList = [];
    this.invalidRowMessage = []; //  Reset the invalid Rows.
    this.userDataService.LocalGetLoginUserInfo().subscribe(loginUserInfo => {
      //setting seesion timeout config
      if (loginUserInfo && loginUserInfo.sessionConfig) {
        this.sessionTimeoutService.initializeSessionConfig(loginUserInfo.sessionConfig.sesionTimeoutInterval,
          loginUserInfo.sessionConfig.sessionAlertInterval, loginUserInfo.sessionConfig.smLogoutUrl);
        this.sessionTimeoutService.startSessionTimer();
      }
      //set logger flag
      if (loginUserInfo && loginUserInfo.uiConsoleLogConfig) {
        let uiConsoleLogConfig = loginUserInfo.uiConsoleLogConfig;
        this.loggingService.enableDebugLog(uiConsoleLogConfig);
      }


      this.loginInfoResponse = loginUserInfo;
      const groups = loginUserInfo.myGroups;
      //Issue- Admin page
      const groupRoles = loginUserInfo.groupRoles;
      const roleName = 'Group Admin';
      const roleNameAdd = 'Supervisor';  //Populate group with “Group Admin” or “Supervisor” role.
      this.autoAssignmentRollOutOrgsList = loginUserInfo.autoAssignmentRollOutOrgsList;
      // Reset the list before populating again.
      this.entGrpName = [];
      this.selectedGroupList = [];
      groups.forEach(element => {
        groupRoles.forEach(group => {
          if ((element.groupName == group.groupName) && (group.groupRole.includes(roleName) || group.groupRole.includes(roleNameAdd))) {
            this.selectedGroupList.push({ 'name': element.groupName });
            this.entGrpName.push({ label: element.groupName, value: element.groupName });
          }
        });
      });

      // Check if user don't have admin access.
      if (this.selectedGroupList === undefined || this.selectedGroupList == null || Object.keys(this.selectedGroupList).length == 0) {
        this.hasGroupRole = false;
      }
      // check org admin user is present or not
      if (loginUserInfo.orgAdminRole && loginUserInfo.orgAdminRole.length > 0) {
        this.isSuperAdminRole = true;
      }
      // Check if loggedInUser has Configured User Admin Role.
      // Check for notification Acess
      this.canSendNotification = loginUserInfo.adminRoles && loginUserInfo.adminRoles.indexOf('Prod Support') > -1;
      //  ISA Admin user can not see the QMA Admin option in QMA 2
      this.isUserAdmin = loginUserInfo.adminRoles && loginUserInfo.adminRoles.indexOf('IS Admin') > -1;
      this.isProdSupport = loginUserInfo.adminRoles && loginUserInfo.adminRoles.indexOf('Prod Support') > -1;
      if (loginUserInfo.configUserAdminRoles && loginUserInfo.configUserAdminRoles.length > 0) {
        this.isUserAdmin = this.isUserAdmin || loginUserInfo.configUserAdminRoles.indexOf('userAdmin') > -1;
        this.isGrpSetupAdmin = loginUserInfo.configUserAdminRoles.indexOf('groupSetupAdmin') > -1;
        this.isMgmtHierarchyAdmin = loginUserInfo.configUserAdminRoles.indexOf('mgmtHierarchyAdmin') > -1;
        this.isDBAdmin = loginUserInfo.configUserAdminRoles.indexOf('dbAdmin') > -1;
        // Check for notification Access
        this.canSendNotification = this.canSendNotification || this.isGrpSetupAdmin;
        this.isMailBoxDLMapping = loginUserInfo.configUserAdminRoles.indexOf('groupSetupAdmin') > -1;
        this.displayAdminSetup = loginUserInfo.configUserAdminRoles.indexOf('groupSetupAdmin') > -1;
      }
      // Group Admin: Bulk group access assignment in QMA"
      loginUserInfo.groupRoles.forEach(element => {
        if ((element.groupRole.indexOf("Group Admin") !== -1 || element.groupRole.indexOf("Supervisor") !== -1)) {
          this.isUserGroupAssignment = true;
        }
      });
      this.isQMAAdmin = this.isUserAdmin || this.isGrpSetupAdmin || this.isDBAdmin || this.canSendNotification || this.isUserGroupAssignment;

      //  Reset the list before populating again.
      this.reqList = [];
      if (loginUserInfo.highlevelRequestTypeList) {
        loginUserInfo.highlevelRequestTypeList.forEach(highlevelRequestType => {
          this.reqList.push(highlevelRequestType);
        });
      }
      if (this.selectedGroupList.length > 0 && Object.keys(this.selectedGroup).length === 0) {
          this.selectedGroup = this.selectedGroupList[0];
          this.selectedAdminGroupName = this.selectedGroup.name;
      }
      this.countryList = loginUserInfo.countryList;
      this.timeZones = loginUserInfo.timeZones;


    })

  }
  /* For Dashboard Popup by OM */
  showAddtoGrpPanel(event, overlaypanel: OverlayPanel): void {
    overlaypanel.toggle(event);
  }

  /* For Profile Setting Popup by OM */

  openProfileSettingDialog() {
    this.displayProfile = true;
    this.editorFlagProfile = true;
    //this.rightNavigationService.close();
  }
  hideProfileModal(isSuccess: boolean) {
    this.displayProfile = false;
    this.editorFlagProfile = false;

    if (isSuccess) {
      this.profileFlag = true;
      //  Timeout Message after Saved Profile Setting
      setTimeout(() => { this.profileFlag = false; }, 3000);
    }
  }


  openAdminDialog() {
    this.display = true;
    this.editorFlag = true;
    /* service call getGroupDataById called in
    open admin panel for performance improvement ,
    previously it was in on initial load*/
    this.onBack()
    this.groupChange();
    //this.rightNavigationService.close();
  }
  groupChangesForInit() {
    this.editorFlag = false;
    this.editorFlag = true;
    this.groupChange();
  }

  initAutoResponseContent() {
    let exp: ExpTinyComponent;
    if (this.editorList.length > 0) {
      this.editorList.forEach(div => {
        if (div.elementId == "autoResponse") {
          exp = div;
          if (this.autoResponse) {
            exp.setData(this.autoResponse);
          }
        }
        if (div.elementId == "emailDisc") {
          exp = div;
          if (this.emailDisc) {
            exp.setData(this.emailDisc);
          }
        }
      });
    }
  }

  showBlankValidation() {

    const flag = this.groupManager == '' ? this.groupManager.trim().length == 0 : false;
    return flag;
  }

  callLookupService(isButtonClicked) {

    this.isLookupClicked = true;

    if (!AppUtils.isUndefinedNullOrBlankStrAfterTrim(this.groupManager)) {
      this.isManagerSelected = true;
      const userID = isButtonClicked ? this.groupManager.trim() : this.groupManagerID;
      this.groupAdminService.getUserDataById({ 'userId': userID }).subscribe(userDetails => {
        this.isL6AndBelow = false;
        if (userDetails !== null) {
          this.validationFlag = false;
          this.groupManagerLevel = userDetails.level;
          let psL5 = userDetails.psL5;
          let psL6 = userDetails.psL6;
          this.managedSegmentData.msL6 = userDetails.msL6;
          this.managedSegmentData.psL5 = userDetails.psL5;
          this.managedSegmentData.psL6 = userDetails.psL6;
          this.managedSegmentData.psL7 = userDetails.psL7;

          this.isUserActiveGD = userDetails.gdActive;
          let userName = userDetails.userName.trim();
          const splitOnSpace = userName.split(' ');
          const first = splitOnSpace[0];
          let last = splitOnSpace[1];
          let name = '';
          if (last != null) {
            last = last.trim();
            name = last != '' ? (last + ', ' + first) : first;
          }
          if (userDetails.gdActive) {
            psL5 = psL5 != null ? psL5.trim() : psL5;
            psL6 = psL6 != null ? psL6.trim() : psL6;
            if (psL6 == name || psL5 == name) {
              this.isL6AndBelow = true;
              if (isButtonClicked) {
                this.closeFlag = true;
              }
              this.grpSaveMsg = 'The Group Manager selected is L6 or above. Please select a Group Manager at an L7 or L8 level or check the attestation box below before your submit.';
              this.inquiryFlag = 0;
            } else {
              this.isL6AndBelow = false;
              this.overrideCheckbox = false;
            }
            if (this.heirarchyData) {
              this.heirarchyData.thirdLevelHeirarchy[0].userName = this.groupManager = userDetails.userName;
              this.heirarchyData.thirdLevelHeirarchy[0].userId = this.groupManagerID = userDetails.userId;
            } else {
              this.groupManager = userDetails.userName;
              this.groupManagerID = userDetails.userId;
            }
          } else {
            this.grpSaveMsg = 'User selected is not active in the Global Directory. Please select another user.';
            this.inquiryFlag = 0;
            this.closeFlag = true;
          }
        } else {
          this.validationFlag = true;
          this.isL6AndBelow = false;
        }
      });
    } else {
      this.isManagerSelected = false;
    }
  }

  getMgtData() {

    if (this.managedSegmentData.msL6) {
      return true;
    }
  }

  previewMail() {
    this.autoResFlagUI = true;
    this.autoResFlagDetails = false;
    this.autoResponse = this.getEditorInstance("autoResponse").getData();
  }
  backToEditor() {
    this.autoResFlagUI = false;
    this.autoResFlagDetails = true;
  }

  downloadForm(type: string) {
    this.selectedFormat = type.toUpperCase();
    if (type === 'csv') {
      this.download_csv();
    } else if (type === 'xls' || type === 'xlsx') {
      // Your existing download logic is already handling both xls and xlsx
      this.download_csv();
    }
    this.isDownloadOpen = false;
  }

  download_csv() {
    if (this.selectedFormat == "CSV") {
      var csv = 'soeid\n';
      var hiddenElement = document.createElement('a');
      hiddenElement.href = 'data:text/csv;charset=utf-8,' + csv;
      hiddenElement.target = '_blank';
      hiddenElement.download = 'Bulk Upload Users Form.csv';
      hiddenElement.click();
    } else if (this.selectedFormat === "XLSX") {
      const NOTES_DETAILS = {
        FILE_NAME: "Bulk Upload Users Form.xlsx",
        SHEET_NAME: "Bulk Upload Users Form",
        HEADERS: ["soeid"]
      }

      const notesDetails: ExcelExport = {
        fileName: NOTES_DETAILS.FILE_NAME,
        sheetName: NOTES_DETAILS.SHEET_NAME,
        header: NOTES_DETAILS.HEADERS,
        data: [],
        width: [15],
        height: 20
      };
      this.excelService.generateExcel(notesDetails);
    }
    else if (this.selectedFormat === "XLS") {
      const BULK_DETAILS = {
        FILE_NAME: "Bulk Upload Users Form.xls",
        SHEET_NAME: "Bulk Upload Users Form",
        HEADERS: ["soeid"]
      }

      const bulkDetails: ExcelExport = {
        fileName: BULK_DETAILS.FILE_NAME,
        sheetName: BULK_DETAILS.SHEET_NAME,
        header: BULK_DETAILS.HEADERS,
        data: [],
        width: [15],
        height: 20
      };
      this.excelService.generateExcel(bulkDetails);
    }
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const downloadSection = event.target as HTMLElement;
    if (!downloadSection.closest('.download-section')) {
      this.isDownloadOpen = false;
    }
  }

  onGridReadyInquiry(params) {
    this.gridApiInquiry = params.api;
    this.gridColumnApiInquiry = params.columnApi;
  }
  gridApiDuplicateInq;
  gridColumnApiDuplicateInquiry;

  onGridDuplicate(params) {
    this.gridApiDuplicateInq = params.api;
    this.gridColumnApiDuplicateInquiry = params.columnApi;
  }

  // select clicked inquiry rule (and make sure it is visible)
  selectInquiryRule(event: any) {
    if (event && event.currentTarget && (event.currentTarget.innerText !== undefined)) {
      let index = parseInt(event.currentTarget.innerText);
      index = Math.max(0, index - 1);
      if (this.gridApiInquiry) {
        let c_node = this.gridApiInquiry.getDisplayedRowAtIndex(index);
        if (c_node) {
          c_node.setSelected(true, true);
          this.gridApiInquiry.ensureIndexVisible(index, 'middle');
          if (this.overlaypanel) {
            this.overlaypanel.hide();
          }
        }
      }
    }
  }

  //  handle inquiry index selection
  handleDupInqSelection() {
    const me = this;
    setTimeout(() => {
      let elems = $('#inquiryRulesGridDuplicate .duplicate-badge');
      if (!elems || !elems.length) {
        return;
      }
      elems.click(event => {
        me.selectInquiryRule(event);
      });
    }, 1000);
  }
  //  Download Inquiry rules as excel

  /**
   *  Method to to download Inquiry rules as Excel file
   */
  download_rules() {
    const displayedColumns = this.gridApiInquiry.getAllDisplayedColumns();
    let columnList = displayedColumns.filter(col => col.colId !== "order").map(column => column.colId);
    let headerMsg = [
      [{ data: { type: "String", value: "The rules in this file will overwrite the rules shown in the screen." }, mergeAcross: 6 }], []
    ];
    let params = {
      customHeader: headerMsg,
      columnKeys: columnList,
      fileName: "Inquiry Rules",
      sheetName: "Inquiry Rules"
    };
    this.gridApiInquiry.exportDataAsExcel(params);
  }

  /**
   *  Method to open the file explorer to browse the file.
   */
  uploadInquiry() {
    this.uploadFilesForInquiry.nativeElement.click();
  }

  /**
   *  Method to upload the inquiry rule and Read the inquiry rules.
   */
  fileEventForInquiry(evt) {
    this.invalidRowMessage = [];
    this.uploadedValidInqRules = [];

    const fileValidationObj = this.validateFileUpload(evt.target.files[0].name);
    if (fileValidationObj.isValid) {
      let fileReader = new FileReader();
      fileReader.onload = (e) => {
        // Reset the upload value for the same file to upload.
        evt.target.value = null;

        let arrayBuffer = fileReader.result;
        let headers = this.excelService.getHeaderRow(arrayBuffer, 1);

        const headerValidateObj = this.validateFileHeader(headers);
        if (headerValidateObj.isValid) {
          let uploadInquiryRules = this.excelService.readExcelContent(arrayBuffer, false, 1);
          const inquiryRulesObj = this.getValidAndInvalidRules(uploadInquiryRules);
          let rejectRowMap = inquiryRulesObj.invalid;
          this.uploadedValidInqRules = [...inquiryRulesObj.valid];
          this.onInquiryRulesConfirm();

          if (rejectRowMap.size > 0) {
            rejectRowMap.forEach((val, key) => {
              let rejectRowsDetails = 'Record #' + key + ' is rejected due to invalid data in ' + val.join(', ') + ' field.\r\n';
              this.invalidRowMessage.push(rejectRowsDetails);
            });
            // Show Rejected Inquiry Rules
            this.inquiryRulesRejected = true;
          }
          else if (this.uploadedValidInqRules.length > 0) {
            this.onInquiryRulesApply();
          }
        }
        else {
          this.onInquiryRulesShowMessage(false, headerValidateObj.errorMessage);
        }
      }
      fileReader.readAsArrayBuffer(evt.target.files[0]);
    }
    else {
      // Reset the upload value for the same file to upload.
      evt.target.value = null;
      this.onInquiryRulesShowMessage(false, fileValidationObj.errorMessage);
    }
  }

  fileDragEventForEntitlement(dragEvent: DragEvent) {

    this.isDragOver = false;
    dragEvent.preventDefault();
    dragEvent.stopPropagation();
    this.errAndSuccess = "";
    this.uploadData = [];

    let files = dragEvent.dataTransfer?.files;

    if (!files || files.length === 0) {
      return;
    }

    // Update the input field with file name
    this.newUserSoeid = files[0].name;

    if (files[0].name.includes(".csv")) {
      let file = files[0];
      let reader = new FileReader();
      reader.readAsText(file);
      reader.onload = (event) => {
        if (!event.target?.['result']) {
          return;
        }
        let arr = (<string>event.target['result']).split('\r\n');
        arr.splice(0, 1)
        if (arr.length > 0) {
          this.getUserListByUpload(arr);
          this.isGroupAdmin = true;
          this.errAndSuccess = "Success Confirmation"
          this.errorMessageForGroupAdmin = " File Uploaded successfully";
          setTimeout(() => { this.isGroupAdmin = false; }, 3000);
        }
      }
    } else if (files[0].name.includes(".xlsx") || files[0].name.includes(".xls")) {
      let fileReader = new FileReader();
      fileReader.onload = (e) => {
        let arrayBuffer = fileReader.result;
        this.bulkUploadData = this.excelService.readExcelContent(arrayBuffer, false);
        this.bulkUploadData.forEach(element => {
          this.uploadData.push(element.soeid)
        });
        if (this.uploadData.length > 0) {
          this.getUserListByUpload(this.uploadData);
          this.isGroupAdmin = true;
          this.errAndSuccess = "Success Confirmation"
          this.errorMessageForGroupAdmin = " File Uploaded successfully";
          setTimeout(() => { this.isGroupAdmin = false; }, 3000);
        }
      }
      fileReader.readAsArrayBuffer(files[0]);
    } else {
      this.isGroupAdmin = true;
      this.errAndSuccess = "Error Message";
      this.errorMessageForGroupAdmin = "File uploaded failed";
      setTimeout(() => { this.isGroupAdmin = false; }, 3000);
    }
  }

  fileEvent(dragEvent) {

    dragEvent.preventDefault();
    dragEvent.stopPropagation();
    this.errAndSuccess = "";
    this.uploadData = [];
    let files = dragEvent.target.files;
    if (dragEvent.target.files[0].name.includes(".csv")) {
      let file = files[0];
      let reader = new FileReader();
      reader.readAsText(file);
      reader.onload = (event) => {
        // null handling for result
        if (!event.target['result']) {
          return;
        }
        let arr = (<string>event.target['result']).split('\r\n');
        arr.splice(0, 1)
        if (arr.length > 0) {
          this.getUserListByUpload(arr); //  Here you can call the above function.
          this.isGroupAdmin = true;
          this.errAndSuccess = "Success Confirmation"
          this.errorMessageForGroupAdmin = " File Uploaded successfully";
          setTimeout(() => { this.isGroupAdmin = false; }, 3000);

        }
      }
    } else if (dragEvent.target.files[0].name.includes(".xlsx") || dragEvent.target.files[0].name.includes(".xls")) {
      let fileReader = new FileReader();
      fileReader.onload = (e) => {
        let arrayBuffer = fileReader.result;
        this.bulkUploadData = this.excelService.readExcelContent(arrayBuffer, false);
        this.bulkUploadData.forEach(element => {
          this.uploadData.push(element.soeid)
        });
        if (this.uploadData.length > 0) {
          this.getUserListByUpload(this.uploadData); // Here you can call the above function.
          this.isGroupAdmin = true;
          this.errAndSuccess = "Success Confirmation"
          this.errorMessageForGroupAdmin = " File Uploaded successfully";
          setTimeout(() => { this.isGroupAdmin = false; }, 3000);
        }
      }
      fileReader.readAsArrayBuffer(dragEvent.target.files[0]);
    } else {
      this.isGroupAdmin = true;
      this.errAndSuccess = "Error Message";
      this.errorMessageForGroupAdmin = "File uploaded failed";
      setTimeout(() => { this.isGroupAdmin = false; }, 3000);
    }
  }

  getUserListByUpload(userList) {
    this.groupAdminService.getValidateBulkUsers({ "userIdList": userList }).subscribe(response => {
      if (response != undefined && response != null) {
        let length = this.addNewUserData.length;
        response.validation.forEach(element => {
          if (element.status == "Valid") {
            element.role = 'Standard User';
          } else {
            element.role = 'NA';
          }
          this.addNewUserData.push(
            { 'user': element.name, 'soeid': element.userId, 'role': element.role, 'status': element.status, 'validID': element.name }
          )
        });
        this.addNewUserGridApi.applyTransaction({ add: this.addNewUserData });
        this.addNewUserData.length == 0 ? this.newUserGridFlag = true : this.newUserGridFlag = false;
        this.uploadFiles.nativeElement.value = "";
        for (var index = length; index < this.addNewUserData.length; index++) {
          this.addNewUserGridApi.startEditingCell({
            rowIndex: index,
            colKey: "ROLE"
          });
        }

      }
    });
  }

  upload_csv() {
    this.uploadFiles.nativeElement.click();
  }

  keyDownFunction(event) {
    this.userEntitlementFlag = false;
    this.newUserSoeIdValidationFlag = false;
    if (event.keyCode == 13) {
      console.log(this.addNewUserData.some(item => item.soeid === this.newUserSoeid))
      if (!AppUtils.isUndefinedNullOrBlankStrAfterTrim(this.newUserSoeid)) {
        this.groupAdminService.getUserDataById({ 'userId': this.newUserSoeid.trim() }).subscribe(userDetails => {
          if (userDetails !== null) {

            let rowData: any[] = [];
            this.entitlementValidationMsg = ''; /*hide error message if user id is available */
            this.addNewUserData.splice(0, 0, { 'user': userDetails.userName, 'soeid': userDetails.userId, 'role': 'Standard User', 'status': 'Valid' });
            this.addNewUserData.length == 0 ? this.newUserGridFlag = true : this.newUserGridFlag = false;
            rowData.splice(0, 0, { 'user': userDetails.userName, 'soeid': userDetails.userId, 'role': 'Standard User', 'status': 'Valid' });

            this.addNewUserGridApi!.applyTransaction({
              add: rowData,
              addIndex: this.addNewUserData.length,
            })!;
            //this.addNewUserGridApi.applyTransaction(this.addNewUserData);
            this.addNewUserGridApi.setFocusedCell(0, "role");
            this.addNewUserGridApi.startEditingCell({
              rowIndex: 0,
              colKey: "ROLE"
            });
          } else if (userDetails == null) {                  /*show error message if user id is not available */
            this.userEntitlementFlag = true;
            this.entitlementValidationMsg = 'User Id not found!';

          }
          this.newUserSoeid = '';
        });
      } else {
        this.newUserSoeIdValidationFlag = true;
      }
    }
  }

  onSelectionChanged() {
    let arr = this.entitleGridApi.getSelectedRows();
    this.entitleSelUser = arr.length;
    if (this.entitleSelUser == 0) {
      this.entitleDelAndGropFlag = true;
    } else {
      this.entitleDelAndGropFlag = false;
    }
  }

  onAddNewUserSelectionChanged() {
    let arr = this.addNewUserGridApi.getSelectedRows();
    this.entitleSelUser = arr.length;
    if (this.entitleSelUser == 0) {
      this.entitleAddUserDelAndGropFlag = true;
    } else {
      this.entitleAddUserDelAndGropFlag = false;
    }
  }

  onSelectionCheck() {
    let arr = this.metaDataGridApi.getSelectedRows();
    this.metadataRecords = arr.length;
    if (this.metadataRecords == 0) {
      this.metaDeleteFlag = true;
    } else {
      this.metaDeleteFlag = false;
    }
  }
  onCategoryCheck() {
    let arr = this.clientCategoryDataGridApi.getSelectedRows();
    this.categoryRecords = arr.length;
    if (this.categoryRecords == 0) {
      this.categoryDeleteFlag = true;
    } else {
      this.categoryDeleteFlag = false;
    }
  }
  onDomainCheck() {
    const activeElement = document.activeElement as HTMLElement;
    if (activeElement && activeElement.tagName === 'INPUT' ) {
      activeElement.blur();
    }
    let arr = this.gridApi.getSelectedRows();
    this.domainRecords = arr.length;
    if (this.domainRecords == 0) {
      this.domainDeleteFlag = true;
    } else {
      this.domainDeleteFlag = false;
    }
  }

  onSelectionRules() {
    let selectedRouteCount = 0;
    let arr = this.gridApiInquiry.getSelectedRows();
    selectedRouteCount = arr.length;
    if (selectedRouteCount == 0) {
      this.rulesDeleteFlag = true;
    } else {
      this.rulesDeleteFlag = false;
    }
  }

  isFirstColumn(params) {
    var displayedColumns = params.api.getAllDisplayedColumns();
    var thisIsFirstColumn = displayedColumns[0] === params.column;
    return thisIsFirstColumn;
  }

  onTabChange(event) {
    this.inquiryFlag = event.index;
    if (this.adminTabs.tabs[event.index].header == "USER ENTITLEMENTS") {
      let res = this.entitleGridApi.getSelectedRows();
      if (res.length == 0) {
        this.entitleDelAndGropFlag = true;
      } else {
        this.entitleDelAndGropFlag = false;
      }
    }
    // Not to show group name at group details page - Jira:4316 - 4 point - By Om
    this.showGroupName = (this.adminTabs.tabs[event.index].header == "GROUP DETAILS") ? false : true;


  }
  onEntitlementUserChange(_index: number) {
    this.tabArray.fill(false);
    this.tabArray[_index] = true;
  }

  deleteNewUserFromEntitlement() {
    this.showPopUpDelete = false; //  Confirmation Dialog before delete
    this.errorMessageForGroupAdmin = "";
    let selectedCount = 0;
    let totalCount = 0;
    let lastIndex = 0;

    var selectedData = this.addNewUserGridApi.getSelectedRows();
    for (let index = 0; index < selectedData.length; index++) {
      if (selectedData[index].role.includes("Group Admin")) {
        selectedCount++;
        lastIndex = index;
      }
    }

    selectedData.forEach(element => {
      if (element['role'].indexOf(',') != -1) {
        let roleArr = element['role'].split(',')
        roleArr = roleArr.map(function (el) {
          return el.trim();
        });
        roleArr.forEach(role => {
          if (role == 'Analyst') {
            this.finAnaArr.push(element['soeid']);
          } else if (role == 'Peer Reviewer') {
            this.finPeerRevArr.push(element['soeid']);
          } else if (role == 'Supervisor') {
            this.finSupArr.push(element['soeid']);
          } else if (role == 'Group Admin') {
            this.finGrpAdmArr.push(element['soeid']);
          }
        });
      } else {
        if (element['role'] == 'Analyst') {
          this.finAnaArr.push(element['soeid']);
        } else if (element['role'] == 'Peer Reviewer') {
          this.finPeerRevArr.push(element['soeid']);
        } else if (element['role'] == 'Supervisor') {
          this.finSupArr.push(element['soeid']);
        } else if (element['role'] == 'Group Admin') {
          this.finGrpAdmArr.push(element['soeid']);
        }
      }
    });

    var res = this.addNewUserGridApi.applyTransaction({ remove: selectedData });

  }

  deleteUserFromEntitlement() {
    this.showPopUpDelete = false; //  Confirmation Dialog before delete
    this.errorMessageForGroupAdmin = "";
    let selectedCount = 0;
    let totalCount = 0;
    let lastIndex = 0;

    var selectedData = this.entitleGridApi.getSelectedRows();
    for (let index = 0; index < selectedData.length; index++) {
      if (selectedData[index].role.includes("Group Admin")) {
        selectedCount++;
        lastIndex = index;
      }
    }

    for (let i = 0; i < this.entitleListBackup.length; i++) {
      if (this.entitleListBackup[i].role.includes("Group Admin")) {
        totalCount++;
      }
    }
    if (selectedCount === totalCount) {
      this.isGroupAdmin = true;
      this.errorMessageForGroupAdmin = "User '" + selectedData[lastIndex].user + "' cannot be removed! The group should have atleast one Group Admin."
      selectedData.splice(lastIndex, 1);
      setTimeout(() => { this.isGroupAdmin = false; }, 3000);
    }
    if (selectedCount === totalCount) {
      this.isGroupAdmin = true;
      this.errAndSuccess = "Error Message";
      this.errorMessageForGroupAdmin = "User '" + selectedData[lastIndex].user + "' cannot be removed! The group should have atleast one Group Admin."
      selectedData.splice(lastIndex, 1);
    }

    selectedData.forEach(element => {
      if (element['role'].indexOf(',') != -1) {
        let roleArr = element['role'].split(',')
        roleArr = roleArr.map(function (el) {
          return el.trim();
        });
        roleArr.forEach(role => {
          if (role == 'Analyst') {
            this.finAnaArr.push(element['soeid']);
          } else if (role == 'Peer Reviewer') {
            this.finPeerRevArr.push(element['soeid']);
          } else if (role == 'Supervisor') {
            this.finSupArr.push(element['soeid']);
          } else if (role == 'Group Admin') {
            this.finGrpAdmArr.push(element['soeid']);
          }
        });
      } else {
        if (element['role'] == 'Analyst') {
          this.finAnaArr.push(element['soeid']);
        } else if (element['role'] == 'Peer Reviewer') {
          this.finPeerRevArr.push(element['soeid']);
        } else if (element['role'] == 'Supervisor') {
          this.finSupArr.push(element['soeid']);
        } else if (element['role'] == 'Group Admin') {
          this.finGrpAdmArr.push(element['soeid']);
        }
      }
    });

    var res = this.entitleGridApi.applyTransaction({ remove: selectedData });
    for (var j = 0; j < selectedData.length; j++) {
      let indx = this.entitleListBackup.map(function (x) { return x.soeid; }).indexOf(selectedData[j].soeid);
      this.entitleListBackup.splice(indx, 1);
    }

  }

  deleteMetaRecords() {
    this.showPopUpDelete = false; // Confirmation Dialog before delete
    this.errorMessageForMetadata = "";
    let selectedMetaData = this.metaDataGridApi.getSelectedRows();
    this.routesList.forEach(element => {
      if (element.at === selectedMetaData[0].tags) {
        this.isExist = true;
        this.errorMessageForMetadata = "Some of Inquiry rules are enabled with Tag '" + element.at + "'. " +
          "please remove '" + element.at + "' Tag from Inquiry rules and ensure '" + element.at + "' Tag is not referred on any of Inquiry Rules then delete the Tag."
        setTimeout(() => { this.isExist = false; }, 3000);
      } else if (element.apr === selectedMetaData[0].processingRegion) {
        this.isExist = true;
        this.errorMessageForMetadata = "Some of Inquiry rules are enabled with Processing Region '" + element.apr + "'. " +
          "please remove '" + element.apr + "' Processing Region from Inquiry rules and ensure '" + element.apr + "' is not referred on any of Inquiry Rules then delete the Processing Region."
        setTimeout(() => { this.isExist = false; }, 3000);
      }
    });
    if (this.metaDataType === 'Root Cause' || this.metaDataType === 'RequestTypes' || !this.isExist) {
      this.metaDataGridApi.applyTransaction({ remove: selectedMetaData });

      // Update metaRowData to remove the selected rows
      selectedMetaData.forEach(element => {
        let key = Object.keys(element)[0];
        let ind = this.metaRowData.findIndex(x => x[key] === element[key]);
        if (ind !== -1) {
          this.metaRowData.splice(ind, 1);  // Remove from metaRowData
        }
      });

      // Update the request type and root cause mapping
      this.updateRequestTypeRootCauseMapping(selectedMetaData, this.metaDataType);
    }
  }

  deleteDomainRecords() {
    this.showPopUpDelete = false;
    let selectedDomainData = this.gridApi.getSelectedRows();
    this.gridApi.applyTransaction({ remove: selectedDomainData });
    selectedDomainData.forEach(element => {
      let ind = this.prdData.map(function (x) { return x.domain; }).indexOf(element.domain);
      this.prdData.splice(ind, 1);
    });
  }
  deleteCategoryRecords() {
    this.showPopUpDelete = false;
    if (!this.clientCategoryDataGridApi) {
      return;
    }
    const selectedData = this.clientCategoryDataGridApi.getSelectedRows();
    if (selectedData && selectedData.length > 0) {
      // Remove from grid
      this.clientCategoryDataGridApi.applyTransaction({ remove: selectedData });

      // Remove from array to keep them in sync, using a stable key instead of object identity
      selectedData.forEach(deletedRow => {
        const index = this.clientCategoryRowData.findIndex(
          row => row && row.categoryName === deletedRow.categoryName
        );
        if (index !== -1) {
          this.clientCategoryRowData.splice(index, 1);
        }
      });

      // For each deleted row, add a new placeholder to maintain the count of 2.
      for (const _ of selectedData) {
        this.onAddCustomCategory();
      }
    }
  }
  deleteInquiryRulesRecords() {
    this.showPopUpDelete = false; // Confirmation Dialog before delete

    // Get selected rows from the grid
    let selectedInquiryRules = this.gridApiInquiry.getSelectedRows();
 if (!selectedInquiryRules || selectedInquiryRules.length === 0) {
      return;
    }

    // Apply transaction to remove selected rows from the grid
    this.gridApiInquiry.applyTransaction({ remove: selectedInquiryRules });

    // Update routesList by filtering out the selected rows
    this.routesList = this.routesList.filter(route =>
      !selectedInquiryRules.some(selectedRule => route.ruleOrder === selectedRule.ruleOrder)
    );

    // Recalculate order for the remaining routes
    this.routesList.forEach((element, index) => {
      element.order = index + 1; // Ensure correct ordering
    });
this.gridApiInquiry.setRowData(this.routesList);
this.excelService.updateRoutesList(this.routesList);
  }

  // Inquiry Rules screen redesign and Rules Reordering
  copyInquiryRecords() {
    const selectedInquiryforCopied = JSON.parse(JSON.stringify(this.gridApiInquiry.getSelectedRows()));
    const coipedRow = selectedInquiryforCopied.length;

    selectedInquiryforCopied.forEach((element, index) => {
      element['order'] = '';
    });
    selectedInquiryforCopied.push(...this.routesList);
    this.routesList = selectedInquiryforCopied;
    this.routesList.forEach((element, index) => {
      element.order = index + 1;
    });
    this.gridApiInquiry.applyTransaction({ add: this.routesList });

    // Select the copied row from the grid.
    setTimeout(() => {
      this.gridApiInquiry.forEachNode(function (node, index) {
        if (index < coipedRow) {
          node.setSelected(true);
        }
        else {
          node.setSelected(false);
        }
      });
    }, 200);
    this.excelService.updateRoutesList(this.routesList);
  }

  checkDuplicate(event): void {
    this.duplicatePanel.toggle(event);

    this.duplicateColumn = [
      // disabling inq rules reorder will be enabled later
      {
        colId: 'rule1',
        field: "rule1",
        headerName: 'RULE',
        width: 145,
        editable: false,
        cellStyle: { 'height': '41px', 'width': '145px' },

      },
      {
        colId: 'value1',
        field: "value1",
        headerName: 'VALUE',
        width: 200,
        editable: false,
        tooltipField: 'value1',
        cellStyle: { 'left': '145px !important', 'width': '200px' }
      },
      {
        colId: 'rule2',
        field: "rule2",
        headerName: 'RULE',
        width: 137,
        editable: false,
        cellStyle: { 'height': '41px', 'left': '345px !important', 'width': '137px' },


      },
      {
        colId: 'value2',
        field: "value2",
        headerName: 'VALUE',
        width: 200,
        editable: false,
        tooltipField: 'value2',
        cellStyle: { 'left': '483px !important', 'width': '200px' }
      },
      {
        colId: 'rule3',
        field: "rule3",
        headerName: 'RULE',
        width: 100,
        editable: false,
        cellStyle: {  'height': '41px', 'left': '682px !important', 'width': '100px' },


      },
      {
        colId: 'value3',
        field: "value3",
        headerName: 'VALUE',
        cellStyle: {  'height': '41px', 'left': '782px !important', 'width': '155px' },
        width: 155,
        editable: false,
        tooltipField: 'value3',
        enableBrowserTooltips: true,
      },
      {
        colId: 'order',
        field: "order",
        headerName: 'RULE#',
        width: 101,
        editable: false,
        cellStyle: { 'left': '937px !important','width': '101px' },
        //cellRendererFramework: InquiryOrderComponent
        cellRenderer: (params) => {
          let indexHtml = '';
          let temp = [];
          params.data.indexList.forEach(element => {
            temp.push(element);
            if (temp.length < 2) {
              //  add class for the span elements
              indexHtml += '<span class="notify-badge-inq-rules duplicat-badge-color-normal duplicate-badge" >' + element + '</span>';
            } else {
              indexHtml += '<span class="notify-badge-inq-rules duplicat-badge-color-warning duplicate-badge" >' + element + '</span>';
            }

          });
          return indexHtml;
        }
      }
    ];
    this.duplicateCheckBox = {
      resizable: true,
      suppressMovable: true,
      suppressMenu: true,
    };
    this.duplicateList = [];
    this.routeListBackup = [];
    var launchOptimistic = this.routesList.map((elem) => {
      return {
        rule1: elem.rule1,
        value1: elem.value1,
        rule2: elem.rule2,
        value2: elem.value2,
        rule3: elem.rule3,
        value3: elem.value3
      }
    });
    let launchFilterd = _.filter(
      _.uniq(
        _.map(launchOptimistic, function (elem) {
          if (_.filter(launchOptimistic, {
            rule1: elem.rule1,
            value1: elem.value1,
            rule2: elem.rule2,
            value2: elem.value2,
            rule3: elem.rule3,
            value3: elem.value3
          }).length > 1) {
            return elem;
          }

          return false;
        })),
      function (value) { return value; });
    let t2 = _.uniqWith(launchFilterd, _.isEqual);
    this.duplicateList = t2;
    this.gridApiDuplicateInq.applyTransaction({ add: this.duplicateList });
    this.duplicateList.forEach(elem => {
      let index = this.routesList.filter(x => (x.rule1 == elem.rule1 && x.value1 == elem.value1 && x.rule2 == elem.rule2 && x.value2 == elem.value2 && x.rule3 == elem.rule3 && x.value3 == elem.value3)).map(x => x.order);
      elem.indexList = index;
    })
  }

  showRestorePopup = false;

  restoreRulesShowPopUp(event): void {

    this.restoreRulesPanel.toggle(event);
    // for Restore button implemention for the rules screen
    this.groupAdminService.getGroupDataByGroup(this.selectedGroup['name']).subscribe((data) => {
      if (data.backupRouteDate) {
        this.restoreInquiryDate = new Date(data.backupRouteDate);
        this.restoreStatus = true;
        this.showRestorePopup = true;
      }
      else {
        this.restoreStatus = false;
      }
    });
  }
  closeRestorePopup(event, overlayPanel) {
    overlayPanel.hide();
  }
  // row data has been populated, registering callback for user clicks
  dupGridRowDataChanged(event: any) {
    this.handleDupInqSelection();
  }

  restoreRules(): void {
    this.routesList = [];
    this.routesList = [...JSON.parse(sessionStorage.getItem('routeListBackup'))];
    this.gridApiInquiry.applyTransaction({ add: [...JSON.parse(sessionStorage.getItem('routeListBackup'))] });
    this.validationRules = '';
    this.excelService.updateRoutesList(this.routesList);
  }
  hideDuplicateModal(overlaypanel) {
    overlaypanel.hide();
  }

  resetMetadata() {
    this.metaDataType = 'RequestTypes';
    this.selectedMetaDataType = 'RequestTypes';
    this.metaRowData = [];
    this.metaRowData = JSON.parse(JSON.stringify(this.metadataBackup));
    this.metaDataGridApi.applyTransaction({ add: this.metadataBackup });
  }

  onBack() {
    this.inquiryFlag = 0;
  }

  getAssignedGroups(selAssignedGrps: any) {
    this.selectedEntGrpName = [];
    selAssignedGrps.forEach(data => {
      this.selectedEntGrpName.push(data.value);
    });
  }

  entitleAggGroup(event, overlaypanel) {
    var selectedData = this.entitleGridApi.getSelectedRows();
    let userList = [];
    selectedData.forEach(element => {
      let roleArr = element.role.split(',');
      if (roleArr.length == 0) {
        userList.push({ "userName": element.user, "soeId": element.soeid, "userRole": element.role });
      } else {
        roleArr.forEach(role => {
          userList.push({ "userName": element.user, "soeId": element.soeid, "userRole": role });
        });
      }
    });
    overlaypanel.hide();
    this.callAssignGroupService(userList, this.selectedEntGrpName)
    this.closeFlagAddGroup = true;
    setTimeout(() => { this.closeFlagAddGroup = false; }, 3000);
    this.selectedEntGrpName = [];
    this.isGroupAdmin = true;
    if (this.userAddGroupMsg) {
      this.errorMessageForGroupAdmin = this.userAddGroupMsg;
    }
  }

  entitleNewAggGroup(event, overlaypanel) {
    var selectedData = this.addNewUserGridApi.getSelectedRows();
    let userList = [];
    selectedData.forEach(element => {
      let roleArr = element.role.split(',');
      if (roleArr.length == 0) {
        userList.push({ "userName": element.user, "soeId": element.soeid, "userRole": element.role });
      } else {
        roleArr.forEach(role => {
          userList.push({ "userName": element.user, "soeId": element.soeid, "userRole": role });
        });
      }
    });
    overlaypanel.hide();
    this.callAssignGroupService(userList, this.selectedEntGrpName)
    this.closeFlagAddGroup = true;
    setTimeout(() => { this.closeFlagAddGroup = false; }, 3000);
    this.selectedEntGrpName = [];
    this.isGroupAdmin = true;
    if (this.userAddGroupMsg) {
      this.errorMessageForGroupAdmin = this.userAddGroupMsg;
    }
  }

  callAssignGroupService(userList, selectedEntGrpName) {
    this.groupAdminService.getBulkAssignUsersToGroups({
      "addToGroup": {
        "groupList": selectedEntGrpName,
        "userList": userList
      }
    }
    ).subscribe(response => {
      if (response !== null) {
        this.userAddGroupMsg = response.message;
      }
    });
  }

  /**
   *  Issue- Unable to save rules for any group error displayed.
   *
   * Method to populate the group entitlements.
   *
   * @param elementList
   */
  entitlementDetails(elementList: any): void {
    this.finAnaArr = [];
    this.finPeerRevArr = [];
    this.finSupArr = [];
    this.finGrpAdmArr = [];
    this.entitleListBackup = [];
    this.entitleDataUserName = [];
    this.groupUsers = [];
    this.entitleData = [];
    elementList.forEach(element => {
      let role = new Set<string>();
      let groupRole = '';
      if (element.groupRoles != null) {
        element.groupRoles.forEach(roleEle => {
          role.add(roleEle.groupRole);
        });
        const roles = Array.from(role);
        groupRole = roles.join(', ');
      }
      this.entitleData.push({ 'user': element.userName, 'soeid': element.userId, 'role': groupRole })
      this.entitleListBackup = JSON.parse(JSON.stringify(this.entitleData));
      //  Populate the User for the group
      this.groupUsers.push(element.userName);
    });
    this.routesList.forEach(element => {
      this.entitleData.forEach(element1 => {
        if (element1.soeid === element.user) {
          element.user = element1.user;
        }
      });
    });
    for (let i = -1; i < this.entitleData.length; i++) {
      if (i === -1) {
        this.entitleDataUserName.push('');
      } else {
        this.entitleDataUserName.push(this.entitleData[i].user);
      }
    }
    this.routesColumn.forEach(i => {
      if (i.colId === 'user') {
        i.cellEditorParams.values = this.entitleDataUserName;
      }
    });
  }

  resetValue() {
    this.version = 0;
    this.gfcid = [];
    this.subjectEscalationList = [];

    this.groupManager = "";
    this.makerCheckerRqd = false;
    this.predictiveRecipients = false;
    this.enableAutoAssignment = false;
    this.enableAutoReplySuggestion = false;
    this.isAutoAssignmentRollOutOrgs = false;
    this.isEmailSharingBlocked = false;
    this.isInquirySourceMandatory = false;
    this.isGfidMandatory = false;
    this.isInqReferenceIdReq = false;
    this.excludeMyGroupWhileReplyAll = false;
    this.hideClientList = false;
    this.supervisiorApprovalForReage = false;
    this.holidayAndShiftDetails = false;
    this.autoResponse = '';
    this.emailDisc = '';
    this.enableAutCliAck = false;
    this.entitleGridApi?.deselectAll();
    this.converThreshold = 0;
    this.resTimeThreHr = null;
    this.resTimeThreMin = null;
    this.penApprThreHr = null;
    this.penApprThreMin = null;
    this.getEditorInstance('autoResponse')?.setData("");
    this.getEditorInstance('emailDisc')?.setData("");
  }

  groupChange() {
    this.testLoad = true;
    this.ClientNameValidation = '';
    this.validationRules = ''; // Inquiry rules validation should be blank if group change
    this.selectedMetaDataType = '';

    // Reset the values before assign new values.
    this.invalidRowMessage = [];
    this.groupRequestTypes = [];
    this.groupProcessingRegion = [];
    this.groupTags = [];
    this.groupRootCauses = [];

    // Admin : Upload User list should clear on change of group.
    this.newUserGridFlag = true;
    this.uploadData = [];
    this.addNewUserData = [];
    this.inqAssignedGroups = [];

    if (!this.hasGroupRole) {
      return;
    }

    const groupEntitlement$ = this.groupAdminService.getGroupDataEntitlement(this.selectedGroup['name']);
    const groupDatabyGroup$ = this.groupAdminService.getGroupDataByGroup(this.selectedGroup['name']);

    // Wait until both the services got resolved.
    forkJoin([groupEntitlement$, groupDatabyGroup$]).subscribe(resultList => {
      this.testLoad = false;
      let groupEntitlements = resultList[0];
      let groupDetailsData = resultList[1];

      this.entitlementDetails(groupEntitlements);
      this.populateGroupDataDetails(groupDetailsData);
    }, error => {
      this.testLoad = false;
      console.error('Error while getting response from getGroupDataByGroup() and getGroupDataEntitlement()');
    });

    /* Automated Response main page will come if group changes */
    this.backToEditor();
  }

  /**
   *  Issue- Unable to save rules for any group error displayed
   *
   * Method to populate group details.
   * @param element
   */
  populateGroupDataDetails(element: any): void {
    this.selectedAdminGroupName = this.selectedGroup['name']
    this.resetValue();
    this.inqAssignedGroups = this.userDataService.getGroupListForRule();
    // this.createRouteColumn();
    this.overrideCheckbox = element.groupManagerAboveL7 == null ? false : element.groupManagerAboveL7;
    // Inquiry Rules screen redesign and Rules Reordering
    this.routesList = [];
    this.routeListBackup = [];
    if (element.routes) {
      element.routes.forEach((route, index) => {
        let obj: any = {};
        obj.order = index + 1;
        obj.field1 = 'From';
        obj.rule1 = route.fromOperator;
        obj.value1 = route.from;
        obj.field2 = 'Subject';
        obj.rule2 = route.subjectOperator;
        obj.value2 = route.subject;
        obj.field3 = 'To';
        obj.rule3 = route.toOperator;
        obj.value3 = route.to;
        obj.checkbox = route.actions.markAsNonInquiry;
        obj.attachment = route.attachment;
        // Inquiry Rules screen redesign and Rules Reordering
        let processing = [];
        if (element.processingRegionList) {
          for (let i = 0; i < element.processingRegionList.length; i++) {
            if (element.processingRegionList[i] === route.actions.assignProcessingRegion)
              processing.push(route.actions.assignProcessingRegion);
          }
        }
        obj.apr = processing;
        let assignRequest = [];
        if (element.requestTypeMappings) {
          for (let i = 0; i < element.requestTypeMappings.length; i++) {
            if (element.requestTypeMappings[i].requestType === route.actions.assignRequestType)
              assignRequest.push(route.actions.assignRequestType);
          }
        }
        obj.art = assignRequest;
        let assigntTag = [];
        if (element.tags) {
          for (let i = 0; i < element.tags.length; i++) {
            if (element.tags[i] === route.actions.assignToTag)
              assigntTag.push(route.actions.assignToTag);
          }
        }
        obj.at = assigntTag;
        let assignUser = [];
        if (this.entitleData) {
          for (let i = 0; i < this.entitleData.length; i++) {
            if (this.entitleData[i].soeid === route.actions.assignToUserId)
              assignUser.push(this.entitleData[i].user);
          }
        }
        obj.user = assignUser;
        obj.assign = route.actions.assignGroup ? route.actions.assignGroup : "";
        obj.ruleOrder = route.ruleOrder;
        obj.deletion = route.actions.markForDeletion;
        this.routesList.push(obj);
      });
    }
    sessionStorage.setItem('routeListBackup', JSON.stringify(this.routesList));
    /* Inquiry Rules screen redesign and Rules Reordering  end */
    // Group Details
    if (element.heirarchyData != null && element.heirarchyData.thirdLevelHeirarchy != null) {
      this.heirarchyData = element.heirarchyData;
      this.groupManager = this.heirarchyData.thirdLevelHeirarchy[0].userName;
      this.groupManagerID = this.heirarchyData.thirdLevelHeirarchy[0].userId;
      this.callLookupService(false);
    }

    // Preferences
    this.makerCheckerRqd = element.makerCheckerRqd;
    this.makerCheckerRqd == true ? this.enablePeerReviewDiv = false : this.enablePeerReviewDiv = true;
;
    element.attachmentBasedMakerChecker == true ? this.peerRevDomain = "Attachments" : this.peerRevDomain = "All";
    this.predictiveRecipients = element.predictiveRecipients;
    this.enableAutoAssignment = element.enableAutoAssignment;
    this.enableAutoReplySuggestion = element.enableAutoReplySuggestion;
    this.isEmailSharingBlocked = element.isEmailSharingBlocked;
    this.isInquirySourceMandatory = element.isInquirySourceMandatory;
    this.isGfidMandatory = element.isGfidMandatory;
    this.isInqReferenceIdReq = element.isInqReferenceIdReq;
    this.excludeMyGroupWhileReplyAll = element.excludeMyGroupWhileReplyAll;
    this.hideClientList = element.hideClientList;
    this.supervisiorApprovalForReage = element.supervisiorApprovalForReage;
    this.requestTypeRootCauseFilter = element.requestTypeRootCauseFilter; // Request Type and Root Cause Linking
    this.isRootCauseMandatory = element.isRootCauseMandatory;
    this.isRootCauseMandatoryWOReply = element.isRootCauseMandatoryWOReply;
    this.isProcessingRegionMandatory = element.isProcessingRegionMandatory;
    this.isTagMandatory = element.isTagMandatory;
    this.enableInquirySubStatus = element.enableInquirySubStatus; // DCC Requirement: Add Case status field


    if (element.holidayAndShiftDetails != null) {
      this.holidayAndShiftDetails = element.holidayAndShiftDetails.holidayBasedAgeCalculation;
    }
    this.holidayAndShiftDetails == true ? this.enableWorkShiftDiv = false : this.enableWorkShiftDiv = true;

    let country = { countryCode: "", countryName: "Select country" }; //  Set with default value
    this.countryList.filter(function (ele) {
      if (ele.countryCode == element.country) {
        country = ele;
      }
    });
    this.selectedCountry = country; // It is required field to save request type.

    let timeZone = { timeZone: "", timeZoneCode: "", timeZoneName: "Select time zone", utcOffset: "" }; // Set with default value
    this.timeZones.filter(function (ele) {
      if (ele.timeZoneCode == element.timeZone) {
        timeZone = ele;
      }
    });
    this.selectedTimeZone = timeZone;

    if (element.holidayAndShiftDetails != null) {
      let startTime;
      this.shifttimeList.filter(function (ele) {
        if (ele.value == element.holidayAndShiftDetails.shiftStartTime) {
          startTime = ele;
        }
      });

      this.selectedWeekelyOff = element.holidayAndShiftDetails.weeklyOffDays;
      this.weekelyOff.map((_day)=>{
        this.selectedWeekelyOff.forEach((_selected)=>{
          if(_selected === _day.value ){
          _day.checked = true;
          }
        })
      })


      let endTime;
      this.shifttimeList.filter(function (ele) {
        if (ele.value == element.holidayAndShiftDetails.shiftEndTime) {
          endTime = ele;
        }
      });
      this.selectedStartTime = startTime;
      this.selectedEndTime = endTime;
    }
    let keepGoing = true;
    if (element && element.heirarchyData && element.heirarchyData.orgHierarchy) {
      element.heirarchyData.orgHierarchy.forEach(obj => {
        if (obj.level == "L2") {
          let orgHierarchyOrgName = obj.orgName.toLowerCase();
          if (this && this.autoAssignmentRollOutOrgsList) {
            this.autoAssignmentRollOutOrgsList.forEach(orgsKeys => {
              if (orgHierarchyOrgName.includes(orgsKeys) && keepGoing) {
                this.isAutoAssignmentRollOutOrgs = true;
                keepGoing = false;
              }
            });
          }
        }
      });
    }


    // Peer review domain
    this.prdData = [];
    if (element.makerCheckerDomains != null) {
      element.makerCheckerDomains.forEach(domainEle => {
        this.prdData.push({ "domain": domainEle, 'domainId': domainEle });
      });
      if (this.gridApi) {
        this.gridApi.applyTransaction({ add: this.prdData })
      }
    }

    // Email Disclaimer
    this.emailDisc = element.disclaimer;

    // Automated Response
    this.autoResponse = element.autoResponseDetails != null ? element.autoResponseDetails[0].value : this.defaultAutoResponse;
    this.enableAutCliAck = element.autoReplyEnable;
    this.isAutoResponseEnabledForInternalDomain = element.isAutoResponseEnabledForInternalDomain;
    this.includeAssignedUserInfo = element?.includeAssignedUserInfo != null ? element?.includeAssignedUserInfo : false;
    this.includeUserContactInfo = element?.includeUserContactInfo != null ? element?.includeUserContactInfo : false;
    this.includeManagerContactInfo = element?.includeManagerContactInfo != null ? element?.includeManagerContactInfo : false;
    setTimeout(() => {
      this.initAutoResponseContent();
    }, 200);

    // Esc criteria
    this.converThreshold = element.convCountThresholdForEscalation > 0 ? element.convCountThresholdForEscalation : 0;

    let escRespTimeThresholdHrs;
    let escRespTimeThresholdMin
    // Group escalation criteria
    if (element.responseTimeThresholdForEscalation && element.responseTimeThresholdForEscalation > 0) {
      escRespTimeThresholdHrs = Math.floor(element.responseTimeThresholdForEscalation / 60);
      escRespTimeThresholdMin = element.responseTimeThresholdForEscalation % 60;

      if (escRespTimeThresholdHrs > 0) {
        this.resTimeThreHr = escRespTimeThresholdHrs;
      }
      if (escRespTimeThresholdMin > 0) {
        this.resTimeThreMin = escRespTimeThresholdMin;
      }
    } else {
      this.resTimeThreHr = null;
      this.resTimeThreMin = null;
    }

    let paEscRespThresholdHrs;
    let paEscRespThresholdMin;
    // Add Escalation criteria for 'Pending Approval' emails
    if (element.paResponseTimeThresholdForEscalation && element.paResponseTimeThresholdForEscalation > 0) {
      paEscRespThresholdHrs = Math.floor(element.paResponseTimeThresholdForEscalation / 60);
      paEscRespThresholdMin = element.paResponseTimeThresholdForEscalation % 60;

      if (paEscRespThresholdHrs > 0) {
        this.penApprThreHr = paEscRespThresholdHrs;
      }
      if (paEscRespThresholdMin > 0) {
        this.penApprThreMin = paEscRespThresholdMin;
      }
    } else {
      this.penApprThreHr = null;
      this.penApprThreMin = null;
    }

    // Addition details
    this.version = element.version;
    this.gfcid = element.gfcid;
    this.subjectEscalationList = element.subjectEscalationList;
    // metadata
    this.requestTypeList = [];
    this.inqRequestTypeList = [];
    //  If requestTypeMappings is null from DB
    if (element.requestTypes && element.requestTypeMappings) {
      element.requestTypeMappings.forEach(requestTypeMapping => {
        requestTypeMapping.requestID = element.requestType;
        this.requestTypeList.push(requestTypeMapping);
        this.inqRequestTypeList.push(requestTypeMapping.requestType);
      });
      this.inqRequestTypeList.unshift("");
    }
    else if (element.requestTypes) {
      element.requestTypes.forEach(requestType => {
        let requestTypeMapping = {};
        requestTypeMapping['requestType'] = requestType;
        requestTypeMapping['highlevelRequestType'] = "";
        requestTypeMapping['requestID'] = element.requestType;

        this.requestTypeList.push(requestTypeMapping);
        this.inqRequestTypeList.push(requestTypeMapping['requestType']);
      });
      this.inqRequestTypeList.unshift("");
    }
    this.rootCauseList = [];
    if (element.rootCauseList) {
      element.rootCauseList.forEach(rootCause => {
        this.rootCauseList.push({ 'rootCause': rootCause, 'rootID': rootCause });
      });
    }
    this.tagsList = [];
    this.inqTagsList = [];
    this.originalTagList = [];
    if (element.tags) {
      this.originalTagList = element.tags;
      element.tags.forEach(tags => {
        this.tagsList.push({ 'tags': tags, 'tagID': tags });
        this.inqTagsList.push(tags);
      });
      this.inqTagsList.unshift("");
    }

    this.processingRegionList = [];
    this.inqprocessingRegionList = [];
    if (element.processingRegionList) {
      element.processingRegionList.forEach(processingRegion => {
        this.processingRegionList.push({ 'processingRegion': processingRegion, 'processID': processingRegion });
        this.inqprocessingRegionList.push(processingRegion);
      });
      this.inqprocessingRegionList.unshift("");
    }

    //  Populate the Request type and Root Cause Mapping
    this.reqTypeRootCauseMap = [];
    this.updatedReqTypeCauseMap = []; // Clear this on group change
    let reqTypeRootCauseMap = element.requestTypeRootCauseMapping;
    if (reqTypeRootCauseMap) {
      for (const [key, value] of Object.entries(reqTypeRootCauseMap)) {
        if (Array.isArray(value)) {
          this.reqTypeRootCauseMap.push({ 'requestType': key, 'rootCause': value });
        }
      }
    }

    this.selectMetaDataType(this.metaDataType, 'onload');
    // inquiry rules
    this.routesColumn.forEach(i => {
      if (i.colId === 'art') {
        i.cellEditorParams.values = this.inqRequestTypeList;
      } else if (i.colId === 'at') {
        i.cellEditorParams.values = this.inqTagsList;
      } else if (i.colId === 'apr') {
        i.cellEditorParams.values = this.inqprocessingRegionList;
      }
    });

    // ClientCategory Data on change of Group
    this.clientCategoryRowData = [];
    if (element.customClientCategory != null && element.customClientCategory != undefined) {
      let clientValue = element.customClientCategory;
      clientValue.forEach(clientValuesRecord => {
        this.clientCategoryRowData.push({
          'categoryName': clientValuesRecord.categoryName,
          'colorCode': clientValuesRecord.colorCode,
          'field': clientValuesRecord.rules.field,
          'operators': clientValuesRecord.rules.operators,
          'value': clientValuesRecord.rules.value
        });
      });
    }

    const rowsNeeded = 2 - this.clientCategoryRowData.length;

    if (rowsNeeded > 0) {
      // Ensure the array has 2 rows before grid initializes and
      // use the same placeholder instances for both the array and the grid.
      const placeholders = [];
      for (let i = 0; i < rowsNeeded; i++) {
        const placeholder = this.createPlaceholderRow();
        this.clientCategoryRowData.push(placeholder);
        placeholders.push(placeholder);
      }

      // If grid is already ready, also add via transaction to sync
      if (this.clientCategoryDataGridApi && placeholders.length > 0) {
        this.clientCategoryDataGridApi.applyTransaction({ add: placeholders });
      }
    }

    // Populate the values from the Group
    this.groupRequestTypes = element.requestTypes ? [...element.requestTypes].sort() : [];
    this.groupProcessingRegion = element.processingRegionList ? [...element.processingRegionList].sort() : [];
    this.groupTags = element.tags ? [...element.tags].sort() : [];
    this.groupRootCauses = element.rootCauseList ? [...element.rootCauseList].sort() : [];

    //for hard code data point
    let secondLevelUserName;
    let orgHierarchyOrgName;
    try {
      // for check second level heirarchy is null or not in hard code data point
      if (element.heirarchyData && element.heirarchyData.orgHierarchy && element.heirarchyData.secondLevelHeirarchy) {
        element.heirarchyData.secondLevelHeirarchy.forEach(obj => {
          secondLevelUserName = obj.userName;
        })
        element.heirarchyData.orgHierarchy.forEach(obj => {
          if (obj.level == "L3") {
            orgHierarchyOrgName = obj.orgName;
          }
        })
        if (secondLevelUserName && orgHierarchyOrgName) {
          this.orgName = orgHierarchyOrgName + '(' + secondLevelUserName + ')';
          let data = { "orgName": this.orgName }
          this.superAdminSetupSerivce.getOrgData(data).subscribe((data: any[]) => {
            this.orgData = data;
            //DCC Requirement: Add Case status field
            if (this.orgData && this.orgData.orgPreferences.enableInquirySubStatus) {
              this.isInquirySubStatusEnabledByOrgAdmin = this.orgData.orgPreferences.enableInquirySubStatus == "true" ? true : false;
              if (this.isInquirySubStatusEnabledByOrgAdmin) {
                this.enableInquirySubStatus = this.isInquirySubStatusEnabledByOrgAdmin;
              } else {
                this.enableInquirySubStatus = element.enableInquirySubStatus;
              }
            }
            if (this.orgData) {
              let enableMetaDataStatus = this.orgData.enableOrgLevelMetaData;
              if (enableMetaDataStatus === undefined) {
                enableMetaDataStatus = false;
              }
              if (enableMetaDataStatus) {// for disable org meta data
                this.displayOrgMetadata = true;
                // check for when enable group level metadata flag is not present in db for hard code data point
                if (this.orgData.orgPreferences && this.orgData.orgPreferences.enableGroupLevelOverride) {
                  let enableStatus = this.orgData.orgPreferences.enableGroupLevelOverride == "true" ? true : false;
                  if (enableStatus) {
                    this.disableGroupMetadataAddOption = enableStatus;
                    if (this.metaDataType === 'RequestTypes' || this.metaDataType === 'Root Cause' || this.metaDataType === 'reqTypeCauseMapping') {
                      this.disableAddMetaDataOption = enableStatus;
                    } else {
                      this.disableAddMetaDataOption = false;
                      this.disableGroupMetadataAddOption = false;
                    }
                    this.setOrgRequestTypeForRuleScreen(this.orgData);
                    this.inqRequestTypeList.sort();
                  } else {
                    this.disableAddMetaDataOption = false;
                    this.disableGroupMetadataAddOption = false;
                    this.setOrgRequestTypeForRuleScreen(this.orgData);
                    this.setRequestTypeForRuleScreen(element);
                    this.inqRequestTypeList.sort();
                  }
                } else {
                  this.setRequestTypeForRuleScreen(element);
                  this.inqRequestTypeList.sort();
                  this.disableGroupMetadataAddOption = false;
                  this.disableAddMetaDataOption = false;
                }
              } else {
                this.displayOrgMetadata = false;
                this.setRequestTypeForRuleScreen(element);
                this.inqRequestTypeList.sort();
                this.disableGroupMetadataAddOption = false;
                this.disableAddMetaDataOption = false;
              }
            } else {
              this.setRequestTypeForRuleScreen(element);
              this.inqRequestTypeList.sort();
              this.disableGroupMetadataAddOption = false;
              this.disableAddMetaDataOption = false;
            }
          });
        } else {
          this.setRequestTypeForRuleScreen(element);
          this.inqRequestTypeList.sort();
          this.orgName = '';
          this.disableGroupMetadataAddOption = false;
          this.disableAddMetaDataOption = false;
          this.displayOrgMetadata = false;
        }
      } else {
        this.setRequestTypeForRuleScreen(element);
        this.orgName = '';
        this.disableGroupMetadataAddOption = false;
        this.disableAddMetaDataOption = false;
        this.displayOrgMetadata = false;
      }
    } catch (error) {
      console.log("Exception has been occured while getting org detail" + error.message);
    }
    this.excelService.updateRoutesList(this.routesList);
    this.createRouteColumn();
  }

  enableShiftCng() {
    this.holidayAndShiftDetails == true ? this.enableWorkShiftDiv = false : this.enableWorkShiftDiv = true;
    // Clear the message when holidayAndShiftDetails is false;
    if (!this.holidayAndShiftDetails) {
      this.workshiftErrMsg = "";
    }
  }

  enablePeerReview() {
    this.makerCheckerRqd == true ? this.enablePeerReviewDiv = false : this.enablePeerReviewDiv = true;
  }

  /**
    * Method to get the Editor instance.
    *
    * @param id - Editor element id
    */
  getEditorInstance(id: string): ExpTinyComponent {
    let exp: ExpTinyComponent;
    this.editorList.forEach(div => {
      if (div && div.elementId == id)
        exp = div;
    });
    return exp;
  }

  hideModal() {
    this.display = false;
    this.editorFlag = false;
    this.validationRules = '';
    this.resetForm();
    this.resetValue();
    this.onBack();
  }
  resetForm() {
    this.showInitial();
    this.ngOnInit();
    this.restoreRules();
    this.resetMetadata();
    this.checkboxListComponent.forEach((comp) => {
      comp.resetCheckList();
    });
    this.newUserGridFlag = true;
    this.addNewUserData = [];
    this.clientCategoryRowData = [];
    this.resetValue();
    this.prdData = [];
  }

  closeModal(_str: any) {
    if (_str == "success") { this.displaySuccess = false; }
    if (_str == "error") { this.displayError = false; }
  }


  onBtStartEditing(key, char, pinned) {
    this.metaTagValidationFlag = false;
    this.metaTagValidationMsg = '';
    let focussedCell = '';
    let newRowData = null;

    if (this.metaDataType === 'RequestTypes') {
      if (this.metaRowData.length === 0 || this.metaRowData[0].requestType !== this.start_typing_placehoder || this.metaRowData[0].requestType !== "") {
        focussedCell = 'requestType';
        newRowData = {
          requestID: "0",
          requestType: this.start_typing_placehoder,
          highlevelRequestType: "Select request type"
        };
      }
    } else if (this.metaDataType === 'Root Cause') {
      if (this.metaRowData.length === 0 || this.metaRowData[0].rootCause !== this.start_typing_placehoder || this.metaRowData[0].rootCause !== "") {
        focussedCell = 'rootCause';
        newRowData = {
          rootCause: this.start_typing_placehoder,
          rootID: "0"
        };
      }
    } else if (this.metaDataType === 'Tags') {
      if (this.metaRowData.length === 0 || this.metaRowData[0].tags !== this.start_typing_placehoder || this.metaRowData[0].tags !== "") {
        focussedCell = 'tags';
        newRowData = {
          tags: this.start_typing_placehoder,
          tagID: "0"
        };
      }
    } else if (this.metaDataType === 'Processing Region') {
      if (this.metaRowData.length === 0 || this.metaRowData[0].processingRegion !== this.start_typing_placehoder || this.metaRowData[0].processingRegion !== "") {
        focussedCell = 'processingRegion';
        newRowData = {
          processingRegion: this.start_typing_placehoder,
          processID: "0"
        };
      }
    }

    if (newRowData) {
      // Add only the new row, not the entire array
      this.metaRowData.splice(0, 0, newRowData);
      // this.metaDataGridApi.applyTransaction({ add: [newRowData] });

      // Apply transaction to add the new row at the top of the grid (row index 0)
      this.metaDataGridApi.applyTransaction({ add: [newRowData], addIndex: 0 });


      // Set focus on the new row and start editing
      this.metaDataGridApi.setFocusedCell(0, focussedCell, pinned);
      this.metaDataGridApi.startEditingCell({
        rowIndex: 0,
        colKey: focussedCell,
        rowPinned: pinned
      });
    }
  }


  addDomain(key, char, pinned) {
    if (this.prdData.length === 0 || this.prdData[0].domain !== "Start Typing") {
      this.prdData.unshift({ domain: "Start Typing", domainId: "0" });
      this.gridApi.applyTransaction({ remove: this.prdData.slice(1) });  // First, remove all rows
      this.gridApi.applyTransaction({ add: this.prdData }); // Then, re-add all rows in the correct order
      this.gridApi.setFocusedCell(0, "domain");
      this.gridApi.startEditingCell({
        rowIndex: 0,
        colKey: "domain"
      });
    }
  }

  addRules(key, char, pinned) {
    // Create a new rule object with default empty values for each field
    let newRule = {
      order: 1,        // Set the initial order
      field1: 'From',
      rule1: 'Begins With',
      value1: '',      // Empty value to be filled later
      field2: 'Subject',
      rule2: 'Begins With',
      value2: '',      // Empty value to be filled later
      field3: 'To',
      rule3: 'Begins With',
      value3: '',      // Empty value to be filled later
      checkbox: false,
      apr: '',
      art: '',
      at: '',
      user: '',
      assign: '',
      attachment: false
    };
    this.inquireSaveButtonFlag = true;

    // Insert the new rule at the beginning of the routesList
    this.routesList.unshift({ ...newRule }); // Ensure a fresh copy of newRule is added

    // Update the order for all rules in the list
    this.routesList = this.routesList.map((element, index) => {
      return {
        ...element,
        order: index + 1  // Re-index the order for all rows
      };
    });

    // Apply the updated list to ag-Grid
    this.gridApiInquiry.setRowData(this.routesList);  // Update the grid with new data

    // Set focus and start editing the newly added rule
    this.gridApiInquiry.setFocusedCell(0, "rule1");
    this.gridApiInquiry.startEditingCell({
      rowIndex: 0,
      colKey: "rule1"
    });
    this.excelService.updateRoutesList(this.routesList);
  }


  selectMetaDataType(metaDataTypeVar, mode?: string) {
    // Metadata Validation for request type
    this.metaTagValidationFlag = false;
    this.metaTagValidationMsg = '';
    this.metaDeleteFlag = true;
    if (mode !== 'onload') {
      if (this.metaDataType === 'RequestTypes') {
        this.requestTypeList = this.metaRowData;
      } else if (this.metaDataType === 'Root Cause') {
        this.rootCauseList = this.metaRowData;
      } else if (this.metaDataType === 'Processing Region') {
        this.processingRegionList = this.metaRowData;
      } else if (this.metaDataType === 'Tags') {
        this.tagsList = this.metaRowData;
      }
      // If not onload, Update the request type - root cause map from the updaed one if any
      if (metaDataTypeVar !== 'reqTypeCauseMapping') {
        if (this.updatedReqTypeCauseMap.length > 0) {
          this.reqTypeRootCauseMap = [...this.updatedReqTypeCauseMap];
          this.updatedReqTypeCauseMap = [];
        }
      }
      if (this.metaRowData && this.metaRowData.length > 0) {
        this.metadataInfo = false;
      }
    }
    this.metaDataType = metaDataTypeVar;
    if (this.metaDataType === 'RequestTypes') {
      this.metaRowData = this.requestTypeList;
      this.metaColumnDefs = [
        {
          colId: 'requestType',
          field: "requestType",
          headerName: 'Request type',
          flex: 1,
          headerCheckboxSelection: true, // Add "Select All" checkbox in the header
          checkboxSelection: true,       // Add checkboxes to rows
          headerCheckboxSelectionFilteredOnly: true,
          editable: (params) => (params.data.requestID == "0") ? true : false,
          sortable: false,
          cellStyle: params => {
            return params.value === 'Start typing' ? { color: '#7E819B'} : { color: '#272727'};
          },
          comparator: function (a, b) {
            if (typeof a === 'string') {
              return a.localeCompare(b);
            } else {
              return (a > b ? 1 : (a < b ? -1 : 0));
            }
          }
        },
        {
          colId: 'highlevelRequestType',
          field: "highlevelRequestType",
          headerName: 'Generic request type',
          flex: 1,
          checkboxSelection: false,
          editable: true,
          sortable: false,
          cellEditor: AgPrimedropdownEditorComponent,
          cellEditorParams: { values: this.reqList, width: '200px'
          },
          cellStyle: (params) => {
            if (params.value === 'Select request type') {
              return { color: '#272727 !important', height: '30px !important' };
            }
            return null;
          }
        },
        {
          colId: '1',
          field: "requestID",
          hide: true,
          headerName: ''
        }
      ];

    } else if (this.metaDataType === 'Root Cause') {
      this.metaRowData = this.rootCauseList;
      this.metaColumnDefs = [
        {
          field: "rootCause",
          editable: (params) => (params.data.rootID == "0") ? true : false,
          sortable: false,
          headerCheckboxSelection: true, // Add "Select All" checkbox in the header
          checkboxSelection: true,       // Add checkboxes to rows
          headerCheckboxSelectionFilteredOnly: true,
          flex: 1,
          cellStyle: params => {
            return params.value === 'Start typing' ? { color: '#7E819B'} : { color: '#272727'};
          },
          comparator: function (a, b) {
            if (typeof a === 'string') {
              return a.localeCompare(b);
            } else {
              return (a > b ? 1 : (a < b ? -1 : 0));
            }
          }
        },
        {
          colId: '1',
          field: "rootID",
          hide: true,
          headerName: ''
        }
      ];
    } else if (this.metaDataType === 'Tags') {
      this.metaRowData = this.tagsList;
      this.metaColumnDefs = [
        {
          field: "tags",
          colId: 'tags',
          sortable: false,
          resizable: false,
          headerCheckboxSelection: true, // Add "Select All" checkbox in the header
          checkboxSelection: true,       // Add checkboxes to rows
          headerCheckboxSelectionFilteredOnly: true,
          flex: 1,
          cellStyle: params => {
            return params.value === 'Start typing' ? { color: '#7E819B'} : { color: '#272727'};
          },
          comparator: function (a, b) {
            if (typeof a === 'string') {
              return a.localeCompare(b);
            } else {
              return (a > b ? 1 : (a < b ? -1 : 0));
            }
          }
        },
        {
          colId: '1',
          field: "tagId",
          hide: true,
          headerName: ''
        }

      ];
    } else if (this.metaDataType === 'Processing Region') {
      this.metaRowData = this.processingRegionList;
      this.metaColumnDefs = [
        {
          field: "processingRegion",
          editable: (params) => (params.data.processID == "0") ? true : false,
          sortable: false,
          resizable: false,
          flex: 1,
          cellStyle: params => {
            return params.value === 'Start typing' ? { color: '#7E819B'} : { color: '#272727'};
          },
          headerCheckboxSelection: true, // Add "Select All" checkbox in the header
          checkboxSelection: true,       // Add checkboxes to rows
          headerCheckboxSelectionFilteredOnly: true,
          comparator: function (a, b) {
            if (typeof a === 'string') {
              return a.localeCompare(b);
            } else {
              return (a > b ? 1 : (a < b ? -1 : 0));
            }
          }
        },
        {
          colId: '1',
          field: "processID",
          hide: true,
          headerName: ''
        }
      ];
    }

    this.metaCheckbox = {
      width: 100,
      checkboxSelection: this.isFirstColumn,
      resizable: true,
      suppressMenu: true,
      suppressMovable: true,
      editable: true,
      cellStyle: { 'height': '41px' }
    };
    // disable add option when org admin disable group level edit option in hard code
    if (this.disableGroupMetadataAddOption) {
      if (this.metaDataType === 'RequestTypes' || this.metaDataType === 'Root Cause' || this.metaDataType === 'reqTypeCauseMapping') {
        this.disableAddMetaDataOption = true;
      } else {
        this.disableAddMetaDataOption = false;
      }
    }
    this.metadataBackup = JSON.parse(JSON.stringify(this.metaRowData));
    if (mode === 'onload') {
      this.metaDataType = '';
    }
  }
  onToggleClientAck(value: boolean): void {
    if(!this.enableAutCliAck && !this.isAutoResponseEnabledForInternalDomain){
      this.autoResponse = this.defaultAutoResponse;
      this.includeAssignedUserInfo = true;
      this.includeUserContactInfo = true;
      this.includeManagerContactInfo = true;
    }
  }
  ngOnInit() {
    this.setHeaderForClientCategory();
    this.auId = this.userDataService.loggedInUserInfo.globalDirectoryConfig.contactInfoConfig.auid;
    this.contactInfoEndPoint = this.userDataService.loggedInUserInfo.globalDirectoryConfig.contactInfoConfig.contactInfoEndPoint;
    this.userDataService.LocalGetLoginUserInfo().subscribe(loginUserInfo => {
      this.enableInquirySubStatusFlag = loginUserInfo.enableInquirySubStatusFlag;
      this.groupChange()
    });

    this.selectedSendInquiry = this.sendInquirys[0];

    this.formatOpenSubscription = this.tabService
      .getFormatOpen()
      .subscribe((isOpen) => {
          this.isFormatOpen = isOpen;
    });
    this.metadataTypeList = [
      { label: 'Request Types', value: 'RequestTypes' },
      { label: 'Root Cause', value: 'Root Cause' },
      { label: 'Request Type/ Root Cause Mapping', value: 'reqTypeCauseMapping' },
      { label: 'Tags', value: 'Tags' },
      { label: 'Processing Region', value: 'Processing Region' },
    ];
    this.selectedMetaDataType = '';
    this.weekelyOff = [
      { label: 'Sun', value: '0',checked:false },
      { label: 'Mon', value: '1' ,checked:false},
      { label: 'Tues', value: '2',checked:false },
      { label: 'Wed', value: '3',checked:false },
      { label: 'Thur', value: '4',checked:false },
      { label: 'Fri', value: '5' ,checked:false},
      { label: 'Sat', value: '6' ,checked:false}
    ];
    this.entitleColumns = [
      {
        field: "user",
        headerName: 'User',
        editable: false,
        headerCheckboxSelection: true,
        checkboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        flex: 1
      },
      {
        field: "soeid",
        headerName: 'User ID',
        editable: false,
        flex: 1,
        checkboxSelection: false
      },
      {
        field: "role",
        headerName: 'Role',
        cellEditor: "agSelectCellEditor",
        cellRenderer: UserEntitlementCheckboxComponent,
        flex: 1,
        checkboxSelection: false
      }
    ];

    this.entitleColDef = {
      headerCheckboxSelection: this.isFirstColumn,
      checkboxSelection: this.isFirstColumn,
      suppressMenu: true,
      resizable: true,
      editable: false,
      cellStyle: { 'background-color': 'white', 'height': '41px' },
      sortable: false,
      flex: 1
    };
    this.rowSelection = "multiple";


    this.addNewUserColumns = [
      {
        field: "user",
        headerName: 'User',
        editable: false,
        headerCheckboxSelection: true,
        checkboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        flex: 1
      },
      {
        field: "soeid",
        headerName: 'User ID',
        editable: false,
        flex: 1,
        checkboxSelection: false
      },
      {
        field: "role",
        headerName: 'Role',
        cellEditor: "agSelectCellEditor",
        cellStyle: { 'white-space': 'normal', 'height': '30px' },
        cellRenderer: UserEntitlementAddCheckboxComponent,
        flex: 1,
        checkboxSelection: false
      },
      {
        colId: '1',
        field: "validID",
        hide: true,
        headerName: ''
      }
    ];

    this.prdColumn = [
      {
        field: "domain",
        headerName: 'Domain Name',
        width: 1027,
        // cellEditor: 'agTextCellEditor',
        editable: (params) => (params.data.domainId == "0") ? true : false,
        sortable: false,
        headerCheckboxSelection: true, // Add "Select All" checkbox in the header
        checkboxSelection: true,       // Add checkboxes to rows
        headerCheckboxSelectionFilteredOnly: true,
        // suppressSizeToFit: true, // Prevent automatic resizing
        // flex: 1,     // Allow this column to grow
        resizable:false,
        cellStyle: params => {
          return params.value === 'Start Typing' ? { color: '#7E819B'} : { color: 'black'};
        }

      },
      {
        colId: '1',
        field: "domainId",
        hide: true,
        headerName: '',
        width:0,

      }]
    this.domainCheckbox = {
      width: 100,
      checkboxSelection: this.isFirstColumn,
      resizable: true,
      suppressMenu: true,
      suppressMovable: true,
      editable: true,
      cellStyle: { 'background-color': 'white', 'height': '41px' }
    };


    this.columnDefs = [
      {
        field: "name",
        width: 100
      },
      {
        field: "gender",
        width: 90
      },
      {
        field: "country",
        width: 100,
        cellEditor: "agRichSelectCellEditor",
        cellEditorParams: {
          cellHeight: 50,
          values: ["Ireland", "USA"]
        }
      },
      {
        field: "city",
        width: 70
      },
      {
        field: "address",
        width: 200,
        cellEditor: "agLargeTextCellEditor"
      }
    ];

    this.defaultColDef = {
      editable: true,
      suppressMovable: true,
      resizable: true
    };
    this.pinnedTopRowData = this.getPinnedTopData();

    //  Populate the system default Client Category to show color code in Custom Client Category screen
    this.clientCategories = this.userDataService.getClientCategory();

    // inq rule reorder
    this.excelService.getinqRulesReorderInfo().subscribe((data: InqRulesReorderInfo) => {
      this.updateInqRuleOrder(data);
    });
    this.groupChange();
  }

  createRouteColumn() {

    // Check for BCC group.
    this.isBccGrpSelected = this.userDataService.isBccGroupSelected(this.selectedGroup.name);
    this.routesColumn = [
      {
        headerName: 'IF (Rules)',
        children: [
          {
            colId: 'order',
            field: "order",
            headerName: 'No.',
            flex: 1,  
            minWidth: 81,
            editable: false,
            cellRenderer: InquiryOrderComponent,
            cellStyle: { 'color': '#fffff' },
            menuTabs: ["filterMenuTab"],
            rowGroupPanelShow: 'always',
            animateRows: true,
            debug: true,
            showToolPanel: true,
            suppressAggFuncInHeader: true,
            purgeClosedRowNodes: true,
            sortable: false,
            filter:false,
            suppressMenu: true
          },
          {
            colId: 'rule1',
            field: "rule1",
            headerName: 'From Rule',
            flex: 1,
            minWidth: 145,
            editable: true,
            cellStyle: { 'color': '#0000EE', 'height': '41px', 'left': '81px !important', 'width': '145px' },
            cellEditor: "agSelectCellEditor",
            cellEditorParams: {
              values: ["Begins With", "Contains", "Not Contains", "Equal", "Not Equal"]
            },
            filter: CustomTextFilterComponent,
            menuTabs: ["filterMenuTab"],
            rowGroupPanelShow: 'always',
            animateRows: true,
            debug: true,
            showToolPanel: true,
            suppressAggFuncInHeader: true,
            purgeClosedRowNodes: true,
            sortable: false,
            suppressMenu: true,
            cellClass: 'cellEdit' ,
          },
          {
            colId: 'value1',
            field: "value1",
            headerName: 'From Value',
            flex: 1,
            minWidth: 145,
            editable: true,
            tooltipField: 'value1',
            cellStyle: { 'left': '226px !important', 'width': '145px' },
            filter: CustomTextFilterComponent,
            menuTabs: ["filterMenuTab"],
            rowGroupPanelShow: 'always',
            animateRows: true,
            debug: true,
            showToolPanel: true,
            suppressAggFuncInHeader: true,
            purgeClosedRowNodes: true,
            sortable: false,
            suppressMenu: true,
            cellClass: 'cellEdit'
          },
          {
            colId: 'rule2',
            field: "rule2",
            headerName: 'Subject Rule',
            flex: 1,
            minWidth: 137,
            editable: true,
            cellStyle: { 'color': '#fffff', 'height': '41px', 'left': '371px !important', 'width': '137px' },
            cellEditor: "agSelectCellEditor",
            cellEditorParams: {
              values: ["Begins With", "Contains", "Not Contains", "Equal", "Not Equal"]
            },
            filter: CustomTextFilterComponent,
            menuTabs: ["filterMenuTab"],
            rowGroupPanelShow: 'always',
            animateRows: true,
            debug: true,
            showToolPanel: true,
            suppressAggFuncInHeader: true,
            purgeClosedRowNodes: true,
            sortable: false,
            suppressMenu: true,
            cellClass: 'cellEdit'
          },
          {
            colId: 'value2',
            field: "value2",
            headerName: 'Subject Value',
            flex: 1,
            minWidth: 190,
            editable: true,
            tooltipField: 'value2',
            cellStyle: { 'left': '508px !important', 'width': '190px' },
            filter: CustomTextFilterComponent,
            menuTabs: ["filterMenuTab"],
            rowGroupPanelShow: 'always',
            animateRows: true,
            debug: true,
            showToolPanel: true,
            suppressAggFuncInHeader: true,
            purgeClosedRowNodes: true,
            sortable: false,
            suppressMenu: true,
            cellClass: 'cellEdit'
          },
          {
            colId: 'rule3',
            field: "rule3",
            headerName: 'To Rule',
            flex: 1,
            minWidth: 130,
            editable: true,
            cellStyle: { 'color': '#0000EE', 'height': '41px', 'left': '698px !important', 'width': '130px' },
            cellEditor: "agSelectCellEditor",
            cellEditorParams: {
              values: ["Begins With", "Contains", "Not Contains", "Equal", "Not Equal"]
            },
            filter: CustomTextFilterComponent,
            menuTabs: ["filterMenuTab"],
            rowGroupPanelShow: 'always',
            animateRows: true,
            debug: true,
            showToolPanel: true,
            suppressAggFuncInHeader: true,
            purgeClosedRowNodes: true,
            sortable: false,
            suppressMenu: true,
            cellClass: 'cellEdit'
          },
          {
            colId: 'value3',
            field: "value3",
            headerName: 'To Value',
            cellStyle: { 'color': '#00bdf2', 'height': '41px', 'left': '828px !important', 'width': '130px' },
            flex: 1,
            minWidth: 130,
            editable: true,
            tooltipField: 'value3',
            enableBrowserTooltips: true,
            filter: CustomTextFilterComponent,
            menuTabs: ["filterMenuTab"],
            rowGroupPanelShow: 'always',
            animateRows: true,
            debug: true,
            showToolPanel: true,
            suppressAggFuncInHeader: true,
            purgeClosedRowNodes: true,
            sortable: false,
            suppressMenu: true,
            cellClass: 'cellEdit'
          },
          {
            colId: 'attachment',
            field: "attachment",
            headerName: 'Attachment',
            flex: 1,
            minWidth: 142,
            editable: false,
            cellStyle: { 'left': '958px !important','border-right':'1px solid red', 'width': '142px' },
            cellRenderer: AgGridCheckboxComponent, cellRendererParams: { fieldname: 'attachment' },
            filter: CustomCheckboxFilterComponent,
            filterParams: {
              // Ensure filter floats above grid content
              suppressAndOrCondition: true,
              floating: true
            },
            menuTabs: ["filterMenuTab"],
            rowGroupPanelShow: 'always',
            animateRows: true,
            debug: true,
            showToolPanel: true,
            suppressAggFuncInHeader: true,
            purgeClosedRowNodes: true,
            sortable: false,
            headerClass: 'header-iflast',
            cellClass: 'header-iflast cellEdit' ,
            suppressMenu: true
          }
        ],
      },


    ];

    this.inquiryRulesChecbox = {
      width: 100,
      checkboxSelection: this.isFirstColumn,
      headerCheckboxSelection: this.isFirstColumn,
      resizable: true,
      suppressMovable: true,
      //suppressMenu: true,
      editable: true,
      cellStyle: { 'height': '41px' },
      filter: true,
      icons: {
        // use font awesome for menu icons
        menu: '',
        menuAlt: '',
        filter: '<i class="fa fa-bars" style="width: 10px;color:#7F8C8D"/>',
        columns: '<i class="fa fa-handshake"/>',
        sortAscending: '<img src="assets/qwyn/icons/sort-asc-single.svg" style="width: 14px; margin-left:4px;height:14px"/>',
        sortDescending: '<img src="assets/qwyn/icons/sort-desc-single.svg" style="width: 14px; margin-left:4px;height:14px"/>'
      },
    };
    this.rowSelection = "multiple";

    if (this.isBccGrpSelected) {
      this.routesColumn.push(
        {
          headerName: 'THEN (Result)',
          children: [
            {
              colId: 'assign',
              field: "assign",
              headerName: 'Assign To Group',
              flex: 1,
              minWidth: 500,
              editable: true,
              cellEditor: "agSelectCellEditor",
              cellStyle: { 'left': '1128px !important', 'width': '450px' },
              cellEditorParams: {
                values: this.inqAssignedGroups
              },
              filter: CustomTextFilterComponent,
              menuTabs: ["filterMenuTab"],
              rowGroupPanelShow: 'always',
              animateRows: true,
              debug: true,
              showToolPanel: true,
              suppressAggFuncInHeader: true,
              purgeClosedRowNodes: true,
              headerClass: 'header-then',
              cellClass: 'cellEdit'
            }
          ],
        },
       );
    }
    else {
      this.routesColumn.push(
        {
          headerName: 'THEN (Result)',
          children: [
            {
              colId: 'checkbox',
              field: "checkbox",
              headerName: 'Non-Inquiry',
              flex: 1,
              minWidth: 150,
              editable: false,
              cellStyle: { 'left': '1100px !important', 'width': '150px'},
              cellRenderer: AgGridCheckboxComponent, cellRendererParams: { fieldname: 'checkbox' },
              filter: CustomCheckboxFilterComponent,
              menuTabs: ["filterMenuTab"],
              rowGroupPanelShow: 'always',
              animateRows: true,
              debug: true,
              showToolPanel: true,
              suppressAggFuncInHeader: true,
              purgeClosedRowNodes: true,
              headerClass: 'header-then',
              suppressMenu: true,
              cellClass: 'cellEdit'
            }, {
              colId: 'user',
              field: "user",
              headerName: 'User',
              flex: 1,  
              minWidth: 130,
              editable: true,
              cellEditor: "agSelectCellEditor",
              cellStyle: { 'left': '1250px !important', 'width': '130px' },
              cellEditorParams: {
                values: this.entitleDataUserName
              },
              filter: CustomTextFilterComponent,
              menuTabs: ["filterMenuTab"],
              rowGroupPanelShow: 'always',
              animateRows: true,
              debug: true,
              showToolPanel: true,
              suppressAggFuncInHeader: true,
              purgeClosedRowNodes: true,
              headerClass: 'header-then',
              suppressMenu: true,
              cellClass: 'cellEdit'
            }, {
              colId: 'art',
              field: "art",
              headerName: 'Request Type',
              flex: 1,
              minWidth: 160,
              editable: true,
              cellEditor: "agSelectCellEditor",
              tooltipField: 'art',
              enableBrowserTooltips: true,
              cellStyle: { 'left': '1380px !important', 'width': '160px' },
              cellEditorParams: {
                values: this.inqRequestTypeList
              },
              filter: CustomTextFilterComponent,
              menuTabs: ["filterMenuTab"],
              rowGroupPanelShow: 'always',
              animateRows: true,
              debug: true,
              showToolPanel: true,
              suppressAggFuncInHeader: true,
              purgeClosedRowNodes: true,
              headerClass: 'header-then',
              suppressMenu: true,
              cellClass: 'cellEdit'
            }, {
              colId: 'at',
              field: "at",
              headerName: 'Tag',
              flex: 1,
              minWidth: 110,
              editable: true,
              cellEditor: "agSelectCellEditor",
              tooltipField: 'at',
              enableBrowserTooltips: true,
              cellStyle: { 'left': '1540px !important', 'width': '110px' },
              cellEditorParams: {
                values: this.inqTagsList
              },
              filter: CustomTextFilterComponent,
              menuTabs: ["filterMenuTab"],
              rowGroupPanelShow: 'always',
              animateRows: true,
              debug: true,
              showToolPanel: true,
              suppressAggFuncInHeader: true,
              purgeClosedRowNodes: true,
              headerClass: 'header-then',
              suppressMenu: true,
              cellClass: 'cellEdit'
            },
              {
                colId: 'apr',
                field: "apr",
                headerName: 'Region',
                flex: 1,
                minWidth: 130,
                editable: true,
                cellEditor: "agSelectCellEditor",
                tooltipField: 'apr',
                enableBrowserTooltips: true,
                cellStyle: { 'left': '1650px !important', 'width': '130px' },
                cellEditorParams: {
                  values: this.inqprocessingRegionList
                },
                filter: CustomTextFilterComponent,
                menuTabs: ["filterMenuTab"],
                rowGroupPanelShow: 'always',
                animateRows: true,
                debug: true,
                showToolPanel: true,
                suppressAggFuncInHeader: true,
                purgeClosedRowNodes: true,
                headerClass: 'header-then',
                suppressMenu: true,
                cellClass: 'cellEdit'
              }
          ],
        },

      );
    }
  }

  getPinnedTopData() {
    return [{
      requestType: "",
      highlevelRequestType: ""
    }];
  }

  onCellValueTxt(params) {
    this.domainMsg = "";
    var colId = params.column.getId();
    if (colId === "domain") {
      this.domainValidationFlag = false;
      let flag = false;
      QmaConstant.domainListAllowed.forEach(element => {
        if (params.data.domain.indexOf(element) !== -1) {
          flag = true;
        }
      });
      if (flag == false) {
        this.domainValidationFlag = true;
        this.domainMsg = "Inappropriate Domain value!";
        this.gridApi.setFocusedCell(params.rowIndex, "domain");
        this.gridApi.startEditingCell({
          rowIndex: params.rowIndex,
          colKey: "domain"
        });
      } else {
        this.domainValidationFlag = false;
      }
    }
  }

  isMetaTagValid(charStr): boolean {
    // Check for Letter and numbers
    const letterNumber = /^[0-9a-zA-Z\.\-\/&\s]+$/;
    const regex = /[↑,←,→,↔,↕,↨,↓,▲,▼,►,◄]/g;
    if ((charStr.match(regex))) {
      return false;
    }

    if (charStr == "") {
      return false;
    }
    if ((charStr.match(letterNumber))) {
      return true;
    }
    // Check for non english character
    else {
      const nonEnglish = /[^\u0000-\u007F]+/;
      if ((charStr.match(nonEnglish))) {
        return true;
      }
    }
    return false;
  }
  isRequestTypeValid(charStr): boolean {
    const regex = /[↑,←,→,↔,↕,↨,↓,▲,▼,►,◄]/g;
    if ((charStr.match(regex))) {
      return false;
    } else {
      return true;
    }
  }

  onkeydown(e) {
    if (e.event.keyCode == 27 && e.data.tagID !== "0") {
      e.node.setDataValue("tags", e.data.tagID);
      this.metaDataGridApi.stopEditing();
    } else if (e.event.keyCode == 27 && e.data.tagID == "0") {
      e.node.setDataValue("tags", null);
      this.metaDataGridApi.startEditingCell({
        rowIndex: e.rowIndex,
        colKey: "tags"
      });
    }
  }

  onCellValueChanged(params) {
    //Reset the Meta Tag Vaildation flag and Message before start validation again.
    this.metaTagValidationFlag = false;
    this.metaTagValidationMsg = ""
    var colId = params.column.getId();
    if (colId === "requestType") {
      const selectedReqType = params.data.requestType;
      const request = this.requestTypeList.filter(reqType => reqType.requestType !== selectedReqType);
      const requestTypeExist = request.map((request, index) => { if (index !== params.rowIndex) return request.requestType }).indexOf(selectedReqType) !== -1;
      const validTag = this.isRequestTypeValid(selectedReqType);
      if (!validTag) {
        this.metaTagValidationFlag = true;
        this.metaTagValidationMsg = 'Invalid name! Only ./&- special characters are allowed.';
        this.metaDataGridApi.startEditingCell({
          rowIndex: params.rowIndex,
          colKey: "requestType"
        });
        return false;
      }
      if (requestTypeExist) {
        this.metaTagValidationFlag = true;
        this.metaTagValidationMsg = 'Request type already exist.';
        this.metaDataGridApi.startEditingCell({
          rowIndex: params.rowIndex,
          colKey: "requestType"
        });
      }
      else if (selectedReqType == "" || selectedReqType == this.start_typing_placehoder) {
        this.metaTagValidationFlag = true;
        this.metaTagValidationMsg = 'Request type value cannot be blank.';
        this.metaDataGridApi.startEditingCell({
          rowIndex: params.rowIndex,
          colKey: "requestType"
        });
      } else if (params.data.highlevelRequestType == "Select request type" || params.data.highlevelRequestType == "") {
        this.metaTagValidationFlag = true;
        this.metaTagValidationMsg = 'Please select matching generic request type in order to add a new request type';
        this.metaDataGridApi.startEditingCell({
          rowIndex: params.rowIndex,
          colKey: "requestType"
        });
      } else {
        this.updateRequestTypeRootCauseOnAdd("requestType", [...this.metaRowData]);
      }
    }
    else if (colId === "rootCause") {
      const selectedRootCause = params.data.rootCause;
      const root = this.rootCauseList.filter(rc => rc.rootcause !== selectedRootCause); // Update logic for already exist
      const rootCausExist = root.map((rc, index) => { if (index !== params.rowIndex) return rc.rootCause }).indexOf(selectedRootCause) !== -1;
      if (rootCausExist) {
        this.metaTagValidationFlag = true;
        this.metaTagValidationMsg = 'Root Cause already exist.';
        this.metaDataGridApi.startEditingCell({
          rowIndex: params.rowIndex,
          colKey: "rootCause"
        });
      }
      else if (selectedRootCause == "" || selectedRootCause == this.start_typing_placehoder) {
        this.metaTagValidationFlag = true;
        this.metaTagValidationMsg = 'Root Cause value can not be blank.';
        this.metaDataGridApi.startEditingCell({
          rowIndex: params.rowIndex,
          colKey: "rootCause"
        });
      } else {
        this.updateRequestTypeRootCauseOnAdd("rootCause", [...this.metaRowData]);
      }
    }
    else if (colId === "tags") {
      const selectedTags = params.data.tags;
      if (selectedTags)
        this.metaTagValidationFlag = false;
      const tag = this.tagsList.filter(tg => tg.tags !== selectedTags); // Update logic for already exist
      const tagsExit = tag.map((tg, index) => { if (index !== params.rowIndex) return tg.tags }).indexOf(selectedTags) !== -1;
      const validTag = this.isMetaTagValid(selectedTags);
      if (tagsExit) {
        this.metaTagValidationFlag = true;
        this.metaTagValidationMsg = 'Tag already exist.';
        this.metaDataGridApi.startEditingCell({
          rowIndex: params.rowIndex,
          colKey: "tags"
        });
      }
      else if (selectedTags == "" || selectedTags == this.start_typing_placehoder) {
        this.metaTagValidationFlag = true;
        this.metaTagValidationMsg = 'Tag value can not be blank.';
        this.metaDataGridApi.startEditingCell({
          rowIndex: params.rowIndex,
          colKey: "tags"
        });
      }

      else if (!validTag) {
        this.metaTagValidationFlag = true;
        this.metaTagValidationMsg = 'Invalid name! Only ./&- special characters are allowed.';
        this.metaDataGridApi.startEditingCell({
          rowIndex: params.rowIndex,
          colKey: "tags"
        });
      }
    }
    else if (colId === "processingRegion") {
      const selectedProcessingRegion = params.data.processingRegion;
      const process = this.processingRegionList.filter(pr => pr.processingRegion !== selectedProcessingRegion);; // Update logic for already exist
      const prRegionExit = process.map((pr, index) => { if (index !== params.rowIndex) return pr.processingRegion }).indexOf(selectedProcessingRegion) !== -1;
      if (prRegionExit) {
        this.metaTagValidationFlag = true;
        this.metaTagValidationMsg = 'Processing Region already exist.';
        this.metaDataGridApi.startEditingCell({
          rowIndex: params.rowIndex,
          colKey: "processingRegion"
        });
      }
      else if (selectedProcessingRegion == "" || selectedProcessingRegion == this.start_typing_placehoder) {
        this.metaTagValidationFlag = true;
        this.metaTagValidationMsg = 'Processing Region value can not be blank.';
        this.metaDataGridApi.startEditingCell({
          rowIndex: params.rowIndex,
          colKey: "processingRegion"
        });
      }
    }
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    params.api.sizeColumnsToFit();
  }

  onMetaDataGridReady(params) {
    this.metaDataGridApi = params.api;
    this.metaDataGridColumnApi = params.columnApi;
    params.api.sizeColumnsToFit();
  }

  onAddNewDataGridReady(params) {
    this.addNewUserGridApi = params.api;
    this.addNewUserGridColumnApi = params.columnApi;
    params.api.sizeColumnsToFit();
  }

  onEntitleGridReady(params) {

    this.entitleGridApi = params.api;
    this.entitleGridColumnApi = params.columnApi;
    params.api.sizeColumnsToFit();
    this.isGridReady = true;

    if (!this.initialPaginationDone) {
      // Trigger pagination programmatically
      this.entitleGridApi.paginationGoToPage(0);
      this.onEntitlementPaginationChanged();
      this.initialPaginationDone = true;
    }
  }

  setIsRootCauseMandatoryWOReply(val) {
    this.isRootCauseMandatoryWOReply = val;
  }
  /**
   * Method to save the admin group details.
   */
  // inquiry rules
  onRowDataChanged(event) {
    event.api.forEachNode(function (rowNode, index) {
      console.log(rowNode + '' + index);
    });
  }

  onCellEditingStopped() {
    // this.onColumnResized();
  }
  onPaginationChanged() {
    if (this.gridApiInquiry) {
      this.lbTotalRecords = this.gridApiInquiry.paginationGetRowCount();
      this.lbPageSize = this.gridApiInquiry.paginationGetPageSize();
      this.lbCurrentPage = this.gridApiInquiry.paginationGetCurrentPage() + 1;
      this.lbTotalPages = this.gridApiInquiry.paginationGetTotalPages();

      let currentPage = this.gridApiInquiry.paginationGetCurrentPage() + 1;
      let lastPage = this.gridApiInquiry.paginationGetTotalPages();
      if (currentPage == lastPage) {
        this.disablePaginationNextLast = true;
      }
      else {
        this.disablePaginationNextLast = false;
      }
      if (currentPage == 1) {
        this.disablePaginationPrevFirst = true;
      }
      else {
        this.disablePaginationPrevFirst = false;
      }
      if (this.lbPageSize > this.lbTotalRecords) {
        this.lbPageSize = this.lbTotalRecords;
      }
      else {
        this.lbPageSize = this.gridApiInquiry.paginationGetPageSize();
      }
    }
  }

  onEntitlementPaginationChanged() {

    if (!this.isGridReady) {
      return; // Skip pagination event if grid is not ready
    }

    if (this.entitleGridApi) {
      this.lbTotalRecordsEntitlement = this.entitleGridApi.paginationGetRowCount();
      this.lbPageSizeEntitlement = this.entitleGridApi.paginationGetPageSize();
      this.lbCurrentPageEntitlement = this.entitleGridApi.paginationGetCurrentPage() + 1;
      this.lbTotalPagesEntitlement = this.entitleGridApi.paginationGetTotalPages();

      let currentPageEntitlement = this.entitleGridApi.paginationGetCurrentPage() + 1;
      let lastPageEntitlement = this.entitleGridApi.paginationGetTotalPages();
      if (currentPageEntitlement == lastPageEntitlement) {
        this.disablePaginationNextLastEntitlement = true;
      }
      else {
        this.disablePaginationNextLastEntitlement = false;
      }
      if (currentPageEntitlement == 1) {
        this.disablePaginationPrevFirstEntitlement = true;
      }
      else {
        this.disablePaginationPrevFirstEntitlement = false;
      }
      if (this.lbPageSizeEntitlement > this.lbTotalRecordsEntitlement) {
        this.lbPageSizeEntitlement = this.lbTotalRecordsEntitlement;
      }
      else {
        this.lbPageSizeEntitlement = this.entitleGridApi.paginationGetPageSize();
      }
    }
  }

  setText(selector, text) {
    document.querySelector(selector).innerHTML = text;
  }
  setLastButtonDisabled(disabled) {
  }
  onBtNext() {
    this.gridApiInquiry.paginationGoToNextPage();
  }
  onBtNextEntitlement() {
    this.entitleGridApi.paginationGoToNextPage();
  }
  onBtPrevious() {
    this.gridApiInquiry.paginationGoToPreviousPage();
  }
  onBtPreviousEntitlement() {
    this.entitleGridApi.paginationGoToPreviousPage();
  }
  onBtLast() {
    this.gridApiInquiry.paginationGoToLastPage();
  }
  onBtLastEntitlement() {
    this.entitleGridApi.paginationGoToLastPage();
  }
  onBtFirst() {
    this.gridApiInquiry.paginationGoToFirstPage();
  }
  onBtFirstEntitlement() {
    this.entitleGridApi.paginationGoToFirstPage();
  }

  // search for inquiry rules
  // onKey(event: any) {
  //   this.gridApiInquiry.setQuickFilter(event.target.value);
  // }


  // search for inquiry rules new implementation
  onKey(event: any) {
    this.gridApiInquiry.setGridOption('quickFilterText', event.target.value);
  }
  filterIconClick() {
    this.filterIconHide = true;
  }
  filterCloseClick() {
    this.filterIconHide = false;
    this.filterText = "";
    this.gridApiInquiry.setQuickFilter("");
  }

  /*  To close success message for Admin */
  closeSuccess() {
    this.closeFlag = false;
  }
  closeAddGroup() {
    this.closeFlagAddGroup = false;
  }

  saveInquiryRules() {
    let saveInquiryRules: SaveInquiryRules = new SaveInquiryRules();
    this.isSaved = true;
    saveInquiryRules.groupName = this.selectedGroup.name;
    saveInquiryRules.version = this.version;
    saveInquiryRules.criteriaList = [];
    this.validationCheck = true;
    this.validationCheckForAction = true;
    this.validationCheckForEmpty = true;
    let validationFailedIds = "";
    // inquiry redesign
    this.routesList.every((element, index) => {
      if ((element.value1 !== '' && element.value1 !== null) || (element.value2 !== '' && element.value2 !== null) || (element.value3 !== '' && element.value3 !== null)) {
        let groupInquiryCriteriaList: GroupInquiryCriteriaList = new GroupInquiryCriteriaList();
        groupInquiryCriteriaList.from = element.value1;
        groupInquiryCriteriaList.fromOperator = element.rule1;
        groupInquiryCriteriaList.ruleOrder = (this.routesList.length - index) * 10;
        groupInquiryCriteriaList.subject = element.value2;
        groupInquiryCriteriaList.subjectOperator = element.rule2;
        groupInquiryCriteriaList.to = element.value3;
        groupInquiryCriteriaList.toOperator = element.rule3;
        groupInquiryCriteriaList.attachment = element.attachment;
        groupInquiryCriteriaList.actions = new GroupInquiryActions();

        if (element.apr && element.apr.length != 0) {
          groupInquiryCriteriaList.actions.assignProcessingRegion = Array.isArray(element.apr) ? element.apr[0] : element.apr;
        }

        if (element.art && element.art.length != 0) {
          groupInquiryCriteriaList.actions.assignRequestType = Array.isArray(element.art) ? element.art[0] : element.art;
        }

        if (element.at && element.at.length != 0) {
          groupInquiryCriteriaList.actions.assignToTag = Array.isArray(element.at) ? element.at[0] : element.at;
        }

        //  Use soeid instead of user name.
        if (element.user && element.user.length != 0) {
          let userName = Array.isArray(element.user) ? element.user[0] : element.user;
          let entitleUser = this.entitleData.find(u => u.user === userName);
          groupInquiryCriteriaList.actions.assignToUserId = entitleUser ? entitleUser.soeid : '';
        }

        if (element.assign && element.assign.length != 0) {
          groupInquiryCriteriaList.actions.assignGroup = Array.isArray(element.assign) ? element.assign[0] : element.assign;
        }

        groupInquiryCriteriaList.actions.markAsNonInquiry = element.checkbox;
        groupInquiryCriteriaList.actions.markForDeletion = element.deletion;

        if (this.isBccGrpSelected) {
          if (!groupInquiryCriteriaList.actions.assignGroup) {
            this.validationCheck = false;
          }
        } else {
          /* Validation issue on save Inquiry */
          this.validationCheck = (!(element.hasOwnProperty("apr") && element.apr?.length == 0) ||
            !(element.hasOwnProperty("art") && element.art?.length == 0) ||
            !(element.hasOwnProperty("at") && element.at?.length == 0) ||
            !(element.hasOwnProperty("user") && element.user?.length == 0) ||
            element.checkbox || element.attachment);
        }
        if (!this.validationCheck) {
          this.validationCheckForAction = false;
          if (validationFailedIds === "") {
            validationFailedIds = element.order;
          } else {
            validationFailedIds = validationFailedIds + ", " + element.order;
          }
        }
        if (this.validationCheck) {
          saveInquiryRules.criteriaList.push(groupInquiryCriteriaList);
        }
        return true;
      } else {
        this.validationCheck = false;
        this.validationCheckForEmpty = false;
        if (validationFailedIds === "") {
          validationFailedIds = element.order;
        } else {
          validationFailedIds = validationFailedIds + ", " + element.order;
        }
        return true;
      }
    });
    if (!this.validationCheckForAction && !this.validationCheckForEmpty) {
      this.validationRules = 'Rules should have atleast one of the To, From & Subject Values  and one action defined: ' + validationFailedIds;
      return false;
    }
    if (this.validationCheckForAction && !this.validationCheckForEmpty) {
      this.validationRules = 'To, From & Subject Values should not be empty for the rule id: ' + validationFailedIds;
      return false;
    }
    if (!this.validationCheckForAction && this.validationCheckForEmpty) {
      this.validationRules = 'Please select at least one action for the rule id: ' + validationFailedIds;
      return false;
    }
    if (this.validationCheckForAction && this.validationCheckForEmpty) {
      saveInquiryRules.criteriaList.forEach(element => {
        this.entitleData.forEach(element1 => {
          if (element.actions.assignToUserId === element1.user) {
            element.actions.assignToUserId = element1.soeid;
          }
        });
      });
      // If click on save button then loader will come
      this.showSpinner = true;

      this.groupAdminService.saveInquiryData(saveInquiryRules).subscribe(result => {
        //this.display = true;
        this.displaySuccess = true;
        this.showSpinner = false;
        this.version = result.version;
        // this.resetValue();
        this.onBack();
        setTimeout(() => { this.displaySuccess = false; }, 3000);
      },
        error => {
          this.display = false;
          this.showSpinner = false;
          this.displayError = true;
          setTimeout(() => { this.displayError = false; }, 3000);
        });
    }
    this.excelService.updateRoutesList(this.routesList);

    setTimeout(() => { this.resetForm(); }, 1000);
  }

  private isRowComplete(row: any): boolean {
    return row.categoryName !== 'Start Typing' &&
      row.field !== 'select field' &&
      row.operators !== 'select rule' &&
      row.value && row.value.trim() !== '' && row.value.trim() !== 'Start Typing';
  }

  private isRowStarted(row: any): boolean {
    return row.categoryName !== 'Start Typing' ||
      row.field !== 'select field' ||
      row.operators !== 'select rule' ||
      (row.value && row.value.trim() !== 'Start Typing' && row.value.trim() !== '');
  }

  /**
   * Creates a placeholder row object for client category grid.
   * @returns A placeholder row object with default values
   */
  protected createPlaceholderRow() {
    return {
      categoryName: "Start Typing",
      colorCode: "",
      field: "select field",
      operators: "select rule",
      value: "Start Typing"
    };
  }

  saveGroup(): void {
    this.testLoad = true;
    this.autoResponseEdit = true;
    this.ClientNameValidation = ''; // Clear any previous messages

    if (this.checkManagerSelected()) {

      if (this.isUserActiveGD) {

        if (this.checkManagerLevel()) {

          if (this.metaTagValidationFlag) {
            this.inquiryFlag = 2; // Navigate to Metadata.
            return;
          }
          let groupDetails: GroupAdminDetails = new GroupAdminDetails();
          let rows = [];
          let clientCtgryList = [];
          if (this.clientCategoryDataGridApi) {
            this.clientCategoryDataGridApi.forEachNode(node => rows.push(node.data));
          } else {
            rows = [...this.clientCategoryRowData];
          }

          // Check if any rows are partially filled and store the result.
          const hadIncompleteRows = rows.some(row => this.isRowStarted(row) && !this.isRowComplete(row));

          // Filter out all incomplete/placeholder rows to create the final save list.
          rows.forEach(clientCatgry => {
            if (this.isRowComplete(clientCatgry)) {
              let clientCategory = {
                "categoryName": clientCatgry.categoryName,
                "colorCode": clientCatgry.colorCode || '#002D72',
                "rules": {
                  "field": clientCatgry.field,
                  "operators": clientCatgry.operators,
                  "value": clientCatgry.value
                }
              };
              clientCtgryList.push(clientCategory);
            }
          });
          groupDetails.customClientCategory = [...clientCtgryList];


          if (this.holidayAndShiftDetails == true) {
            if (this.selectedCountry['countryCode'] == "" ||
              this.selectedTimeZone['timeZoneCode'] == "" ||
              this.selectedStartTime == undefined ||
              this.selectedStartTime['value'] == "" ||
              this.selectedEndTime == undefined ||
              this.selectedEndTime['value'] == "") {
              this.workshiftErrMsg = "Country, TimeZone, Shift start and end time are mandatory fields for this configuration";
              this.inquiryFlag = 3;
              return;
            }
          } else {
            this.workshiftErrMsg = ""; //
          }

          // Group Details
          groupDetails.groupName = this.selectedGroup.name;
          if (this.heirarchyData)
            groupDetails.heirarchyData = this.heirarchyData;

          // entitlement
          let finAddAnaArr = [];
          let finAddPeerRevArr = [];
          let finAddSupArr = [];
          let finAddGrpAdmArr = [];

          this.addNewUserData.forEach(element => {

            if ((element['role'].indexOf('Analyst') > -1) || (element['role'].indexOf('Standard User') > -1)) {
              finAddAnaArr.some(item => item === element['soeid']) ? null : finAddAnaArr.push(element['soeid']);
            }
            if ((element['role'].indexOf('Peer Reviewer') > -1)) {
              finAddPeerRevArr.some(item => item === element['soeid']) ? null : finAddPeerRevArr.push(element['soeid']);
            }
            if ((element['role'].indexOf('Supervisor') > -1)) {
              finAddSupArr.some(item => item === element['soeid']) ? null : finAddSupArr.push(element['soeid']);
            }
            if ((element['role'].indexOf('Group Admin') > -1)) {
              finAddGrpAdmArr.some(item => item === element['soeid']) ? null : finAddGrpAdmArr.push(element['soeid']);
            }
          });

          this.entitleData.forEach(element => {
            this.entitleListBackup.forEach(oldElement => {
              if (oldElement['soeid'] == element['soeid']) {
                /* Add in Array */
                if ((element['role'].includes('Analyst') || element['role'].includes('Standard User')) && !(oldElement['role'].includes('Analyst'))) {
                  finAddAnaArr.some(item => item === element['soeid']) ? null : finAddAnaArr.push(element['soeid']);
                }
                if (element['role'].includes('Peer Reviewer') && !(oldElement['role'].includes('Peer Reviewer'))) {
                  finAddPeerRevArr.some(item => item === element['soeid']) ? null : finAddPeerRevArr.push(element['soeid']);
                }
                if (element['role'].includes('Supervisor') && !(oldElement['role'].includes('Supervisor'))) {
                  finAddSupArr.some(item => item === element['soeid']) ? null : finAddSupArr.push(element['soeid']);
                }
                if (element['role'].includes('Group Admin') && !(oldElement['role'].includes('Group Admin'))) {
                  finAddGrpAdmArr.some(item => item === element['soeid']) ? null : finAddGrpAdmArr.push(element['soeid']);
                }
                /* Remove from Array */
                // User Entitlement drop down not refelecting after save.
                if ((oldElement['role'].indexOf('Analyst') >= 0 || oldElement['role'].indexOf('Standard User') >= 0) && (element['role'].indexOf('Analyst') == -1)) {
                  this.finAnaArr.some(item => item === element['soeid']) ? null : this.finAnaArr.push(element['soeid']);
                }
                if ((oldElement['role'].indexOf('Peer Reviewer') >= 0) && (element['role'].indexOf('Peer Reviewer') == -1)) {
                  this.finPeerRevArr.some(item => item === element['soeid']) ? null : this.finPeerRevArr.push(element['soeid']);
                }
                if ((oldElement['role'].indexOf('Supervisor') >= 0) && (element['role'].indexOf('Supervisor') == -1)) {
                  this.finSupArr.some(item => item === element['soeid']) ? null : this.finSupArr.push(element['soeid']);
                }
                if ((oldElement['role'].indexOf('Group Admin') >= 0) && (element['role'].indexOf('Group Admin') == -1)) {
                  this.finGrpAdmArr.some(item => item === element['soeid']) ? null : this.finGrpAdmArr.push(element['soeid']);
                }
              }
            });
          });

          groupDetails.supervisorAddList = finAddSupArr;
          groupDetails.analystAddList = finAddAnaArr;
          groupDetails.adminAddList = finAddGrpAdmArr;
          groupDetails.peerRevAddList = finAddPeerRevArr;

          groupDetails.supervisorRemoveList = this.finSupArr;
          groupDetails.analystRemoveList = this.finAnaArr;
          groupDetails.adminRemoveList = this.finGrpAdmArr;
          groupDetails.peerRevRemoveList = this.finPeerRevArr;


          // Prefrences
          groupDetails.domainReqd = this.makerCheckerRqd;
          this.peerRevDomain == "Attachments" ? groupDetails.attachmentIncluded = true : groupDetails.attachmentIncluded = false;
          groupDetails.predictiveRecipients = this.predictiveRecipients;
          groupDetails.enableAutoAssignment = this.enableAutoAssignment;
          groupDetails.enableAutoReplySuggestion = this.enableAutoReplySuggestion;
          groupDetails.isEmailSharingBlocked = this.isEmailSharingBlocked;
          groupDetails.isInquirySourceMandatory = this.isInquirySourceMandatory;
          groupDetails.isGfidMandatory = this.isGfidMandatory;
          groupDetails.enableInquirySubStatus = this.enableInquirySubStatus; //DCC Requirement: Add Case status field
          groupDetails.isInqReferenceIdReq = this.isInqReferenceIdReq;
          groupDetails.excludeMyGroupWhileReplyAll = this.excludeMyGroupWhileReplyAll;
          groupDetails.hideClientList = this.hideClientList;
          groupDetails.supervisiorApprovalForReage = this.supervisiorApprovalForReage;

          // Set requestTypeRootCauseFilter from UI to group.
          groupDetails.requestTypeRootCauseFilter = this.requestTypeRootCauseFilter;
          groupDetails.isHolidayBasedAgeCalculation = this.holidayAndShiftDetails;

          groupDetails.groupCountryValue = this.selectedCountry['countryCode'];
          groupDetails.groupTimeZoneValue = this.selectedTimeZone['timeZoneCode'];
          groupDetails.groupShiftStartTime = this.selectedStartTime && this.selectedStartTime['value'] ? this.selectedStartTime['value'] : "";
          groupDetails.groupShiftEndTime = this.selectedEndTime && this.selectedEndTime['value'] ? this.selectedEndTime['value'] : "";
          groupDetails.weekelyOff = this.selectedWeekelyOff || [];

          // Peer review Domain
          groupDetails.domainList = [];
          if ((this.prdData).length > 0 && this.prdData[0].domain == "Start Typing") {
            this.domainValidationFlag = true;
            this.domainMsg = "Field value can not be blank."
            this.inquiryFlag = 4;
            return;
          }

          this.prdData.forEach(element => {
            if (element['domain'] != "")
              groupDetails.domainList.push(element['domain'])
          });

          // Emain Disc
          this.emailDisc = this.getEditorInstance('emailDisc')?.getData()||'';
          groupDetails.disclaimer = '';

          // Add check condition if disclaimer contains only spaces
          if (this.emailDisc) {
            let parsedHtml = this.parser.parseFromString(this.emailDisc, 'text/html');
            let viewContent = parsedHtml.body.innerText || "";
            if (viewContent.replace(/\s/g, '').length > 0) {
              groupDetails.disclaimer = this.emailDisc;
            }
          }

          // Auto Response
          groupDetails.autoReplyEnable = this.enableAutCliAck;
          groupDetails.isAutoResponseEnabledForInternalDomain = this.isAutoResponseEnabledForInternalDomain;
          groupDetails.includeAssignedUserInfo = this.includeAssignedUserInfo;
          groupDetails.includeUserContactInfo = this.includeUserContactInfo;
          groupDetails.includeManagerContactInfo = this.includeManagerContactInfo;
          if (this.autoResponse != null) {
            groupDetails.autoResponseDetails.push({
              "key": "groupName",
              "value": this.getEditorInstance('autoResponse')?.getData()?.trim() || ''
            });
          }


          // Escalation Criteria
          //  handling 0 and undefined cases (in form and component)
          let convCountThresholdForEscalation = 0;
          if (groupDetails.convCountThresholdForEscalation) {
            convCountThresholdForEscalation += (+groupDetails.convCountThresholdForEscalation);
          }
          if (this.converThreshold) {
            convCountThresholdForEscalation += (+this.converThreshold);
          }
          groupDetails.convCountThresholdForEscalation = convCountThresholdForEscalation;

          let responseTimeThresholdForEscalation = 0;
          if (this.resTimeThreMin) {
            responseTimeThresholdForEscalation = responseTimeThresholdForEscalation + (+this.resTimeThreMin);
          }
          if (this.resTimeThreHr) {
            responseTimeThresholdForEscalation = responseTimeThresholdForEscalation + (+this.resTimeThreHr) * 60;
          }
          groupDetails.responseTimeThresholdForEscalation = responseTimeThresholdForEscalation;

          //  Add Escalation criteria for 'Pending Approval' emails
          let paResponseTimeThresholdForEscalation = 0;
          if (this.penApprThreMin) {
            paResponseTimeThresholdForEscalation = paResponseTimeThresholdForEscalation + (+this.penApprThreMin);
          }
          if (this.penApprThreHr) {
            paResponseTimeThresholdForEscalation = paResponseTimeThresholdForEscalation + (+this.penApprThreHr) * 60;
          }
          groupDetails.paResponseTimeThresholdForEscalation = paResponseTimeThresholdForEscalation;

          groupDetails.version = this.version;
          if (this.gfcid)
            groupDetails.gfcid = this.gfcid;
          groupDetails.subjectEscalationList = this.subjectEscalationList;

          // Metadata
          if (this.metaRowData) {
            if (this.metaDataType === 'RequestTypes') {
              this.requestTypeList = this.metaRowData;
            } else if (this.metaDataType === 'Root Cause') {
              this.rootCauseList = this.metaRowData;
            } else if (this.metaDataType === 'Processing Region') {
              this.processingRegionList = this.metaRowData;
            } else if (this.metaDataType === 'Tags') {
              this.tagsList = this.metaRowData;
            }
          }

          if (((this.metaRowData).length > 0) && (this.metaRowData[0].requestType == this.start_typing_placehoder ||
            this.metaRowData[0].highlevelRequestType == this.start_typing_placehoder || this.metaRowData[0].tags == this.start_typing_placehoder ||
            this.metaRowData[0].rootCause == this.start_typing_placehoder || this.metaRowData[0].processingRegion == this.start_typing_placehoder)) {
            this.metaTagValidationFlag = true;
            this.metaTagValidationMsg = 'Field value can not be blank.';
            this.inquiryFlag = 2;
            return;
          }
          else {
            this.metaTagValidationFlag = false;
            this.metaTagValidationMsg = "";

          };
          groupDetails.rootCauseList = [];
          this.rootCauseList.forEach(el => groupDetails.rootCauseList.push(el.rootCause));
          groupDetails.processingRegionList = [];
          this.processingRegionList.forEach(el => groupDetails.processingRegionList.push(el.processingRegion));
          groupDetails.requestTypeMappings = this.requestTypeList;
          groupDetails.requestTypeMappings.forEach(el => delete el['requestID'])
          groupDetails.requestTypeList = [];
          this.requestTypeList.forEach(el => groupDetails.requestTypeList.push(el.requestType));
          groupDetails.isTagMandatory = this.isTagMandatory;
          groupDetails.isRootCauseMandatory = this.isRootCauseMandatory;
          groupDetails.addGroupTags = [];
          groupDetails.editGroupTags = [];
          groupDetails.deleteGroupTags = [];
          this.tagsList.forEach(el => {
            if (el.tagID == "0") groupDetails.addGroupTags.push(el.tags);
            else if (el.tagID !== "0" && el.tagID !== el.tags) groupDetails.editGroupTags.push({ 'tagName': el.tagID, "newtagName": el.tags });
          });
          for (let el of this.originalTagList) {
            let isExists = this.tagsList.filter(tags => tags.tagId != '0' && tags.tagID == el)[0];
            if (!isExists) groupDetails.deleteGroupTags.push(el);
          }
          groupDetails.isRootCauseMandatoryWOReply = this.isRootCauseMandatoryWOReply;
          groupDetails.isProcessingRegionMandatory = this.isProcessingRegionMandatory;

          //Validate Request type and Request type mapping should have atleast one value.
          if (groupDetails.requestTypeList.length == 0 || groupDetails.requestTypeMappings.length == 0) {
            this.metaTagValidationFlag = true;
            this.metaTagValidationMsg = 'At least one request type is required.'; //Jira :  4703 : Metadata Validation for request type
            this.inquiryFlag = 2;
            return;
          }

          // User can get the validation error when there is request type in QMA 2.0 without mapping to generic request type.
          let nonGenericRequestType = groupDetails.requestTypeMappings.filter(reqType => reqType.highlevelRequestType == "");
          if (nonGenericRequestType && nonGenericRequestType.length > 0) {
            // Pre-select the meta-data type as Request type and populates the value
            this.selectedMetaDataType = 'RequestTypes';
            this.selectMetaDataType('RequestTypes', 'onchange');
            this.metaTagValidationFlag = true;
            this.metaTagValidationMsg = 'Request type should be mapped with generic request type.';
            this.inquiryFlag = 2;
            return;
          }
          // C170665-10 | Populate Request Type and Root Cause mapping.
          groupDetails.requestTypeRootCauseMapping = this.getReqTypeRootCauseMappingList(groupDetails.requestTypeList, groupDetails.rootCauseList);
          //C170665-185 | enable organization meta data
          groupDetails.enableOrganizationMetaData = this.enableOrgMetaData;

          // If click on save button then loader will come
          this.showSpinner = true;
          groupDetails.isGroupManagerAboveL7 = this.overrideCheckbox;
          groupDetails.managerSoeId = this.groupManagerID;
          this.groupAdminService.saveGroupData(groupDetails).subscribe(result => {

            // Group Data Saved Successfully
            if (result?.success) {
              this.messageService.add({ severity: 'success', key: 'qmaToast', summary: '', detail: 'Your changes have been saved successfully.' });

              // After a successful save, display the client category informational message
              if (hadIncompleteRows) {
                // Update the value after a second as we're resetting it elsewhere in the code.
                setTimeout(() => {
                  this.ClientNameValidation = 'Note: Any incomplete custom categories were not saved. Please ensure all fields are filled out before saving.';
                  setTimeout(() => { this.ClientNameValidation = ''; },
                    this.CLEAR_CLIENT_CATEGORY_MESSAGE_AFTER);
                }, this.SHOW_CLIENT_CATEGORY_MESSAGE_DELAY);
              }

              //this.resetValue();
              this.onBack();
              this.addNewUserData = [];
              this.version = result.version;
              this.grpSaveMsg = this.userSavedSuccess;
              this.showSpinner = false;
              this.testLoad = false;
              this.closeFlag = true;
              if (this.closeFlag) {
                setTimeout(() => { this.closeFlag = false; }, 3000);
              }
              // Update the group to loggedIn User once group is updated successfully.
              this.userDataService.setGroupDetails(groupDetails);
              this.errorMessageForGroupAdmin = result.message;
            } else if (result && !result.success) {
              this.testLoad = false;
              this.messageService.add({ severity: 'error', key: 'qmaToast', summary: '', detail: result.message });
            }
            // If another user has already updated the details
            else {
              this.testLoad = false;
              //  Show validation message from service.
              let errMsg = result.validationMessage ? result.message : this.concurrentUpdateMsg;
              this.errorMessageForGroupAdmin = errMsg;
              this.grpSaveMsg = errMsg;
              this.closeFlag = true;
              this.showSpinner = false;
              if (this.closeFlag) {
                setTimeout(() => { this.closeFlag = false; }, 10000);
              }
            }
            this.display = false;
          },
            error => {
              this.testLoad = false;
              this.showSpinner = false;
              console.error('Error while saving group admin details in saveGroup()');
            });
        } else {
          this.grpSaveMsg = 'The Group Manager selected is L6 or above. Please select a Group Manager at an L7 or L8 level or check the attestation box below before your submit.';
          this.errorMessageForGroupAdmin =this.grpSaveMsg;
          this.closeFlag = true;
          this.inquiryFlag = 0;
          this.isManagerSelected = false;
          return;
        }
      } else {
        this.grpSaveMsg = 'User selected is not active in Global Directory. Please select another user.';
        this.errorMessageForGroupAdmin =this.grpSaveMsg;
        this.closeFlag = true;
        this.inquiryFlag = 0;
        return;
      }
    } else {
      this.grpSaveMsg = 'Group Manager is not selected';
      this.closeFlag = true;
      this.inquiryFlag = 0;
      return;
    }
  }

  // Check if Group Manager is selected
  checkManagerSelected(): boolean {

    this.isManagerSelected = true;
    if (AppUtils.isUndefinedNullOrBlankStrAfterTrim(this.groupManager)) {
      this.isManagerSelected = false;
    } else {
      this.isManagerSelected = true;
    }
    return this.isManagerSelected;
  }

  // Check if level is correct
  checkManagerLevel(): boolean {

    return !this.isL6AndBelow || (this.isL6AndBelow && this.overrideCheckbox);
  }
  /* Set header for client category - 12-09-2019 */
  setHeaderForClientCategory() {
    this.clientCategoryColumnDefs = [
      {
        colId: 'customClientCategory',
        field: "categoryName",
        headerName: 'Custom Category',
        width: 218,
        editable: true,
        sortable: false,
        headerCheckboxSelection: true, // Add "Select All" checkbox in the header
        checkboxSelection: true,       // Add checkboxes to rows
        headerCheckboxSelectionFilteredOnly: true,
        cellStyle: params => {
          return params.value === 'Start Typing' ? { color: '#7E819B',borderRight :'1px solid #D8D9E5', } : { color: 'black',borderRight :'1px solid #D8D9E5', };
        }

      },
      {
        colId: 'displayColor',
        field: "colorCode",
        headerName: 'Color Code',
        width: 200,
        editable: false,
        cellRenderer: ColorPickerComponent,
        sortable: false,
        cellStyle: () => {
          return {
            borderRight :'1px solid #D8D9E5',
          };
        }
      },
      {
        colId: 'field',
        field: "field",
        headerName: 'Field',
        width: 200,
        editable: true,
        cellEditor: "agSelectCellEditor",
        cellEditorParams: {
          values: ["From", "To", "Subject", "Tag"],
        },
        sortable: false,
        cellStyle: params => {
          return params.value === 'select field' ? { color: '#7E819B',borderRight :'1px solid #D8D9E5', } : { color: 'black',borderRight :'1px solid #D8D9E5', };
        }
      },
      {
        colId: 'operators',
        field: "operators",
        headerName: 'Rule',
        width: 200,
        editable: true,
        cellEditor: "agSelectCellEditor",
        cellEditorParams: {
          values: ["Contains", "Starts With", "Ends With", "Equals"]
        },
        sortable: false,
        cellStyle: params => {
          return params.value === 'select rule' ? { color: '#7E819B',borderRight :'1px solid #D8D9E5', } : { color: 'black',borderRight :'1px solid #D8D9E5', };
        }
      },
      {
        colId: 'value',
        field: "value",
        headerName: 'Value',
        width: 200,
        editable: true,
        sortable: false,
        cellStyle: params => {
          return params.value === 'Start Typing' ? { color: '#7E819B',borderRight :'1px solid #D8D9E5', } : { color: 'black',borderRight :'1px solid #D8D9E5', };
        }
      },
      // {
      //   colId: 'delete',
      //   field: "",
      //   headerName: '',
      //   width:133,
      //   editable: false,
      //   cellRenderer: DeleteCellRendererComponent,
      //   sortable: false,
      // }
    ];
  }
  /**
   * Method to call when client category grid is ready.
   * @param params
   */
  onGridReadyClient(params) {
    this.clientCategoryDataGridApi = params.api;
    this.clientCategoryDataGridColumnApi = params.columnApi;
    params.api.sizeColumnsToFit();

    // Ensure we have 2 rows when grid is ready
    setTimeout(() => {
      if (typeof params.api?.getDisplayedRowCount !== 'function') {
        return;
      }
      const currentGridRowCount = params.api.getDisplayedRowCount();

      if (currentGridRowCount < 2) {
        const rowsNeeded = 2 - currentGridRowCount;
        const placeholders = [];
        for (let i = 0; i < rowsNeeded; i++) {
          placeholders.push(this.createPlaceholderRow());
        }
        // Add to both grid and array
        if (this.clientCategoryDataGridApi) {
          this.clientCategoryDataGridApi.applyTransaction({ add: placeholders });
        }
        this.clientCategoryRowData.push(...placeholders);
      }
    }, 100);
  }

  /* Add new Custom category */
  onAddCustomCategory() {
    // Guard against the grid not being ready
    if (!this.clientCategoryDataGridApi) {
      return;
    }

    const newPlaceholder = this.createPlaceholderRow();

    // Add to the grid and underlying data array
    this.clientCategoryDataGridApi.applyTransaction({ add: [newPlaceholder] });
    this.clientCategoryRowData.push(newPlaceholder);
  }
  onCellValueChangedClient(params) {
    this.ClientNameValidation = '';

    // Skip validation for placeholder category names
    if (!params.data?.categoryName || params.data.categoryName === 'Start Typing') {
      return;
    }

    const catName = params.data.categoryName.trim();
    if (!catName) {
      return;
    }

    // Get the current row index - try rowIndex first, then node.rowIndex
    let currentRowIndex: number | undefined;
    if (params.rowIndex !== undefined) {
      currentRowIndex = params.rowIndex;
    } else if (params.node?.rowIndex !== undefined) {
      currentRowIndex = params.node.rowIndex;
    }

    if (currentRowIndex === undefined) {
      return;
    }

    // Check for duplicate category names in other rows
    const hasDuplicate = this.clientCategoryRowData.some((row, index) => {
      // Skip the current row and placeholder rows
      if (index === currentRowIndex || !row.categoryName || row.categoryName === 'Start Typing') {
        return false;
      }
      return row.categoryName.toLowerCase().trim() === catName.toLowerCase();
    });

    if (hasDuplicate) {
      this.ClientNameValidation = 'Custom category name already exist.';
      // Keep editing the current cell to allow user to fix it
      if (this.clientCategoryDataGridApi) {
        this.clientCategoryDataGridApi.startEditingCell({
          rowIndex: currentRowIndex,
          colKey: "customClientCategory"
        });
      }
    }
  }

  closeErrorModal() {
    this.errorMessage = false;
  }

  closeErrorMetadata() {
    this.isExist = false;
  }
  closeErrorUserEnt() {
    this.isGroupAdmin = false;

  }

  /**
   * Method to close profile setting popup on success.
   * @param event
   */
  closeProfileSetting(event: any): void {
    if (event) {
      this.hideProfileModal(event);
    }
  }

  onReject() {
    this.messageService.clear('c');
  }

  sanetize(value: any): any {
    return this.sanatized.bypassSecurityTrustHtml(value);
  }

  /**
   * Method to Navigate to QMA 1.0
   */
  openQMAdmin(): void {
    this.groupSetupBoolean = true;
  }
  onGrpSetupMdlClosed(data) {
    this.groupSetupBoolean = false;
  }
  updateInqRuleOrder(inqRulesReorderInfo: InqRulesReorderInfo) {
    if (Object.entries(inqRulesReorderInfo).length === 0 && inqRulesReorderInfo.constructor === Object) {
      return;
    }
    this.removeInqRuleFromGrid(inqRulesReorderInfo);

  }

  removeInqRuleFromGrid(inqRulesReorderInfo: InqRulesReorderInfo) {
    // Inquiry Rules screen redesign and Rules Reordering
    const inquiryRuletoDelete = this.routesList.findIndex(irowData => irowData.order === inqRulesReorderInfo.originalOrderNumber);
    this.routesList.splice(inquiryRuletoDelete, 1);
    // Inquiry Rules screen redesign and Rules Reordering
    let nodeToReOrder = [];

    this.gridApiInquiry.forEachNode(function (node) {
      if (inqRulesReorderInfo.originalOrderNumber === node.data.order) {
        // Inquiry Rules screen redesign and Rules Reordering
        nodeToReOrder.push(node.data)
      }
    });
    if (nodeToReOrder.length > 0) {
      this.gridApiInquiry.applyTransaction({ remove: nodeToReOrder });
    }
    this.addInqRuleAtNewPosition(inqRulesReorderInfo, nodeToReOrder[0]);
    this.excelService.updateRoutesList(this.routesList);

  }
  addInqRuleAtNewPosition(inqRulesReorderInfo: InqRulesReorderInfo, nodeToReOrder) {
    this.routesList.splice(inqRulesReorderInfo.newOrderNumber - 1, 0, nodeToReOrder);
    this.gridApiInquiry.applyTransaction({
      add: [nodeToReOrder],
      addIndex: inqRulesReorderInfo.newOrderNumber - 1
    });
  }

  //  Confirmation Dialog before delete
  /**
  * Method to prepare and set the required values to confirmation pop.
  * */
  setConfirmation(tab): void {
    //Metadata Validation for request type
    this.metaTagValidationFlag = false;
    this.metaTagValidationMsg = '';
    if (tab == 'metaData' && this.metaRowData.length == 1 && this.metaDataType === 'RequestTypes') {
      this.metaTagValidationFlag = true;
      this.metaTagValidationMsg = 'At least one request type is required.';
      this.inquiryFlag = 2;
      return;
    }
    else if (tab == 'metaData' && this.metaRowData.length == 1 && this.metaDataType === 'Root Cause') {
      this.metaTagValidationFlag = true;
      this.metaTagValidationMsg = 'At least one root cause is required.';
      this.inquiryFlag = 2;
      return;
    }
    else if (tab == 'metaData' && this.metaRowData.length == 1 && this.metaDataType === 'Processing Region') {
      this.metaTagValidationFlag = true;
      this.metaTagValidationMsg = 'At least one processing region is required.';
      this.inquiryFlag = 2;
      return;
    }
    else if (tab == 'metaData' && this.metaRowData.length == 1 && this.metaDataType === 'Tags') {
      this.metaTagValidationFlag = true;
      this.metaTagValidationMsg = 'At least one tags is required.';
      this.inquiryFlag = 2;
      return;
    }
    // Delete dialog should show if inquiry rules is selected.
    else if (tab == "inquiryRules") {
      this.isSaved = false;
      const selectedRules = this.gridApiInquiry.getSelectedRows();
      if (null == selectedRules || selectedRules.length == 0) {
        return;
      }
    }
    this.showPopUpDelete = true;
    this.confirmMsgText = "Are you sure want to delete the selected items ?";
    this.groupTab = tab;
  }
  onCancel() {
    this.showPopUpDelete = false;
  }
  onOk() {
    if (this.groupTab == 'peerReview') {
      this.deleteDomainRecords();
    }
    if (this.groupTab == 'metaData') {
      this.deleteMetaRecords();
    }
    if (this.groupTab == 'userEntitlement') {
      this.deleteUserFromEntitlement();
    }
    if (this.groupTab == 'newUserEntitlement') {
      this.deleteNewUserFromEntitlement();
    }
    if (this.groupTab == 'inquiryRules') {
      this.deleteInquiryRulesRecords();
    }
    if (this.groupTab == 'clientCategory') {
      this.deleteCategoryRecords();
    }

  }

  //  Validation for Uploaded Inquiry Rules
  /**
   * Method to validate the uploaded file type.
   * @param fileName
   */
  validateFileUpload(fileName: string): any {
    let validateObj = { isValid: true, errorMessage: '' };

    // Upload file should be Excel i.e extension should be .xlsx
    if (!fileName.includes('.xlsx')) {
      validateObj.isValid = false;
      validateObj.errorMessage = 'File upload failed due to invalid file type; only supported file type is .xlsx';
    }
    return validateObj;
  }

  /**
   * Method to validate the upload file has same header as of grid header except sequence column.
   * @param headers
   */
  validateFileHeader(headers: any): any {
    let validateObj = { isValid: true, errorMessage: '' };
    let displayedColumList = this.gridApiInquiry.getAllDisplayedColumns()
    let columnList = displayedColumList.filter(col => col.colId !== "order").map(column => column.colDef.headerName);
    // Validate that upload Excel and Grid have same columns.
    let isHeaderValid = true;
    if (columnList.length === headers.length && columnList.every(col => headers.includes(col))) {
      for (let idx = 0; idx < columnList.length; idx++) {
        isHeaderValid = columnList[idx] === headers[idx];
        if (!isHeaderValid) {
          return;
        }
      }
    } else {
      isHeaderValid = false;
    }

    if (!isHeaderValid) {
      validateObj.isValid = isHeaderValid;
      validateObj.errorMessage = 'File Upload failed due to incorrect headers';
    }
    return validateObj;
  }

  /**
   * Method to get the valid and invalid inquiry rules from the uploaded rules.
   * @param uploadInquiryRules
   */
  getValidAndInvalidRules(uploadInquiryRules: any): any {

    let rejectRowMap = new Map();
    let validInquiryRules = [];

    for (let i = 0; i < uploadInquiryRules.length; i++) {
      let rejectedColArr = [];
      let rowData = uploadInquiryRules[i];

      if (this.isBccGrpSelected) {
        if (rowData['Assign To Group'] && !this.inqAssignedGroups.includes(rowData['Assign To Group'])) {
          rejectedColArr.push('Assign To Group');
        }
      }
      else {
        // Validate the fields
        if (rowData['USER'] && !this.groupUsers.includes(rowData['USER'])) {
          rejectedColArr.push('User');
        }

        if (rowData['REQUEST TYPE'] && !this.groupRequestTypes.includes(rowData['REQUEST TYPE'])) {
          rejectedColArr.push('Request Type');
        }

        if (rowData['TAG'] && !this.groupTags.includes(rowData['TAG'])) {
          rejectedColArr.push('Tag');
        }

        if (rowData['REGION'] && !this.groupProcessingRegion.includes(rowData['REGION'])) {
          rejectedColArr.push('Region');
        }
      }

      if (rejectedColArr.length > 0) {
        rejectRowMap.set(i + 1, rejectedColArr);
      } else {
        validInquiryRules.push(rowData);
      }
    };

    const inquiryRulesObj = {
      'invalid': rejectRowMap,
      'valid': validInquiryRules
    }
    return inquiryRulesObj;
  }

  /**
   * Method to update the inquiry rules grid with upload inquiry rules.
   * @param validInquiryRules
   */
  updateInquiryRulesGrid(validInquiryRules: any): void {
    if (validInquiryRules.length > 0) {
      /* jira C170665-1815-DL-rule-not-working-when-bulk-rules-upload-is-done-through-UI */
      const defValue = "Begins With";
      let inquiryRuleList = [...this.routesList];
      validInquiryRules.forEach((rowData, i) => {
        let inquiryRule = {
          'order': i + 1, // Show row seq as per number of records.
          'rule1': rowData['From Rule'] != "" ? rowData['From Rule'] : defValue,
          'value1': rowData['From Value'],
          'rule2': rowData['Subject Rule'] != "" ? rowData['Subject Rule'] : defValue,
          'value2': rowData['Subject Value'],
          'rule3': rowData['To Rule'] != "" ? rowData['To Rule'] : defValue,
          'value3': rowData['To Value'],
          'checkbox': "true" === rowData['Non-Inquiry'],
          'user': rowData['User'],
          'art': rowData['Request Type'],
          'at': rowData['Tag'],
          'apr': rowData['Region'],
          'assign': rowData['Assign To Group'],
          'attachment': "true" === rowData['Attachment']
        };
        inquiryRuleList.push(inquiryRule);

      });
      inquiryRuleList.forEach((element, index) => {
        element.order = index + 1;
      });
      this.gridApiInquiry.applyTransaction({ add: inquiryRuleList });
      this.routesList = [];
      this.routesList = [...inquiryRuleList];

      let message = 'Inquiry Rules are created successfully !';
      this.onInquiryRulesShowMessage(true, message);
    }
    this.excelService.updateRoutesList(this.routesList);
  }

  /**
   *  On Show Inquiry Rules Upload messages
   */
  onInquiryRulesShowMessage(isSuccess: boolean, message: string): void {
    this.inquiryRulesUpload = true;
    this.inquiryRulesMsgTitle = isSuccess ? 'Success Message' : 'Error Message';
    this.inquiryRulesMsg = message;

    //  Timeout Message
    setTimeout(() => {
      this.inquiryRulesUpload = false;
      this.inquiryRulesMsgTitle = '';
      this.inquiryRulesMsg = '';
    }, 3000);
  }

  /**
   *  Method to show the overwrite rule confirmation popup.
   */
  onInquiryRulesApply(): void {
    let overwriteMsg = 'The rules from the uploaded file will overwrite the existing set of rules in the screen.';
    this.inquiryRulesConfirm = true;
    this.inquiryRulesMsg = overwriteMsg;
  }

  /**
   *   Method called when user confirm to override the existing inquiry rules.
   */
  onInquiryRulesConfirm(): void {
    this.onInquiryRulesCancel();
    this.updateInquiryRulesGrid(this.uploadedValidInqRules);
  }

  /**
   *  Method called when user cancle to override the existing inquiry rules.
   */
  onInquiryRulesCancel(): void {
    this.inquiryRulesConfirm = false;
    this.inquiryRulesMsg = '';
  }

  /**
   *   Method called when user confirm or cancel for Rejected inquiry rules.
   */
  onInquiryRulesRejectedConfirm(): void {
    this.inquiryRulesRejected = false;
    if (this.uploadedValidInqRules.length > 0) {
      this.onInquiryRulesApply();
    }
  }

  /**
   * Method to download failed Inquiry rules
   */
  onDownloadLogs(): void {
    this.excelService.downloadAsText(this.invalidRowMessage, "Rejected_Inquiry_Rules");
  }

  /**
   * Method to close Panel
   */
  closePanel() {
    this.rightNavigationService.close();
    this.activeMenuArray[7] = false;
  }

  /**
   *  Admin - escalation criteria can be saved with -ve values.
   * On enter number.
   *
   * @param e
   */
  onEnterNumber(e: KeyboardEvent): boolean {
    if (!((e.keyCode > 95 && e.keyCode < 106) || (e.keyCode > 47 && e.keyCode < 58 || e.keyCode == 8))) {
      return false;
    }
  }

  //  Restore button implemention for the rules screen
  restoreRule(): void {
    this.routesList = [];
    this.validationRules = '';
    const restoreRulesDatabyGroup$ = this.groupAdminService.getGroupRestoreRulesDataById(this.selectedGroup['name']);
    restoreRulesDatabyGroup$.subscribe((data) => {
      let groupData = data;
      this.populateGroupDataDetails(groupData);
    });
    this.excelService.updateRoutesList(this.routesList);
    this.showRestorePopup = false
  }
  // for cancel restore operation
  cancelRestorePopup() {
    this.showRestorePopup = false
    const groupDatabyGroup$ = this.groupAdminService.getGroupDataByGroup(this.selectedGroup['name']);
    groupDatabyGroup$.subscribe((data) => {
      let groupData = data;
      this.populateGroupDataDetails(groupData);
    });
  }
  // Open QMA Admin modal windows
  openQMAAdmin(): void {
    this.displayUserAdmin = true;
  }
  closeQMAAdmin(data: any): void {
    this.displayUserAdmin = false;
  }
  // Open send user notification windows modal
  sendEmailNotification(): void {
    this.displaySendUserNotification = true;
  }

  closeSendEmailNotification(data: any): void {
    this.displaySendUserNotification = false;
  }

  onMenuClick(_clickedItemIndex: number, _expand: boolean, _option: string = '', _count?: number) {
    let clickedItem = this.activeMenuArray[_clickedItemIndex];
    this.activeMenuArray.fill(false);
    this.activeMenuArray[_clickedItemIndex] = _expand ? !clickedItem : true;
    this.hideSubMenu = _expand;
    if (_option) {
      this.hideSubMenu = false;
    }
  }

  openDatabaseAdmin(): void {
    this.displayDatabaseAdmin = true;
  }
  closeDatabaseAdmin(data: any): void {
    this.displayDatabaseAdmin = false;
  }

  /**
   *  Method to update the request type and root cause mapping on delete operation.
   *
   * @param deleteItem
   * @param metaDataType
   */
  updateRequestTypeRootCauseMapping(deleteItem: any, metaDataType: string): void {
    let rtrcMap = [...this.reqTypeRootCauseMap];
    let updatedMap = [];
    let rootCausesList = [];
    let requestTypeList = []

    if (metaDataType === 'Root Cause') {
      rootCausesList = this.metaRowData.map(data => data.rootCause);
      let deletedItem = deleteItem[0].rootCause;

      rtrcMap.forEach(item => {
        let rootCause = item.rootCause.filter(rc => rc !== deletedItem);
        if (rootCause && rootCause.length > 0) {
          updatedMap.push({ 'requestType': item.requestType, 'rootCause': rootCause });
        }
      });
    }
    else if (metaDataType === 'RequestTypes') {
      requestTypeList = this.metaRowData.map(data => data.requestType);
      let deletedItem = deleteItem[0].requestType;

      rtrcMap.forEach(item => {
        if (item.requestType !== deletedItem) {
          updatedMap.push({ 'requestType': item.requestType, 'rootCause': item.rootCause });
        }
      });
    }

    // Update the Request Type and Root cause mapping.
    if (requestTypeList.length > 0) {
      this.groupRequestTypes = [...requestTypeList].sort();
    }
    if (rootCausesList.length > 0) {
      this.groupRootCauses = [...rootCausesList].sort();
    }
    this.reqTypeRootCauseMap = [...updatedMap];
  }

  /**
   * Method to update the request type and root cause on adding new.
   *
   * @param metaDataType
   * @param metaData
   */
  updateRequestTypeRootCauseOnAdd(metaDataType: string, metaData: any[]): void {
    let rootCausesList = [];
    let requestTypeList = []

    if (metaDataType === "requestType") {
      requestTypeList = metaData.map(data => data.requestType);
      this.groupRequestTypes = [...requestTypeList].sort();
    }
    else if (metaDataType === "rootCause") {
      rootCausesList = metaData.map(data => data.rootCause);
      this.groupRootCauses = [...rootCausesList].sort();
    }
  }

  /**
   * Method to handle the request when request type and root cause mapping is applied.
   * @param event
   */
  onApplyMapping(event: any): void {
    this.updatedReqTypeCauseMap = [...event];
  }

  /**
   * Method to validate and get the request type and root cause mapping list.
   *
   * @param requestTypes
   * @param rootCauses
   */
  getReqTypeRootCauseMappingList(requestTypes: string[], rootCauses: any): any {
    let requestTypeRootCauseMapping = {};
    let mapping = [];

    if (this.updatedReqTypeCauseMap.length > 0) {
      mapping = [...this.updatedReqTypeCauseMap];
    }
    else {
      mapping = [...this.reqTypeRootCauseMap];
    }

    mapping.forEach(item => {
      if (requestTypes.includes(item.requestType)) {
        let rootCauseList: [] = item['rootCause'];
        let existingRootCauseList = rootCauseList.filter(e => rootCauses.includes(e));
        if (existingRootCauseList.length > 0) {
          requestTypeRootCauseMapping[item.requestType] = existingRootCauseList;
        }
      }
    });
    return requestTypeRootCauseMapping;
  }

  openMailBoxDLMapping(): void {
    this.isMailBoxDLMappingPopup = true;
  }
  closeMailboxDLMappingPopup(event): void {
    this.isMailBoxDLMappingPopup = false;
  }
  openUserGroupAssignment(): void {
    this.isUserGroupAssignmentPopup = true;
  }
  closeUserGroupAssignment(event): void {
    this.isUserGroupAssignmentPopup = false;
  }
  openAdminSetup(): void {
    this.displayAdminSetupPopup = true;
  }
  closeAdminSetup(data: any): void {
    this.displayAdminSetupPopup = false;
  }
  logout(): void {
    this.sessionTimeoutService.cvLogout();
  }
  activateSession(): void {
    this.sessionAlertPopup = false;
    this.userDataService.restoreUserSession().subscribe(
      data => {
        this.sessionTimeoutService.resetCounter();
      },
      error => {
        console.log(error);
      }
    );

  }
  closeSessionPopup(): void {
    this.sessionAlertPopup = false;
  }
  subscribeSessionAlert(): void {
    this.sessionTimeoutService.sessionWarning.subscribe(
      data => {
        this.sessionAlertPopup = data;
      },
      error => {
        console.log(error);
      }
    );
  }

  openSuperAdminDialog() {
    this.displaySuperAdminSetup = true;
  }
  closeSuperAdminDialog(data: any): void {
    this.displaySuperAdminSetup = false;
  }
  getOrgData(orgName) {
    try {
      let data = {
        "orgName": orgName
      }
      this.superAdminSetupSerivce.getOrgData(data).subscribe((data: any[]) => {
        this.orgData = data;
        if (this.orgData && this.orgData.orgPreferences.enableGroupLevelOverride) {
          this.disableGroupMetadataAddOption = this.orgData.orgPreferences.enableGroupLevelOverride;
        } else {
          this.disableGroupMetadataAddOption = false;
        }
      });
    } catch (error) {
      console.log("Exceptin has occured in UserComponent.getOrgData" + error.message);
    }
  }
  setRequestTypeForRuleScreen(element) {
    //if (element.requestTypeMappings) {
      // element.requestTypeMappings.forEach(requestTypeMapping => {
        // this.inqRequestTypeList.push(requestTypeMapping.requestType);
       //})
     //}

  }
  // for set org request type in rule screen
  setOrgRequestTypeForRuleScreen(orgData) {
    if (orgData.highLevelRequestTypeMapping) {
      orgData.highLevelRequestTypeMapping.forEach(requestTypeMapping => {
        this.inqRequestTypeList.push(requestTypeMapping.requestType);
      });
    }
  }

  overrideChange(e) {
    this.overrideCheckbox = e.target.checked;
  }
  togglePeerReviewInfo(){
    this.peerReviewInfo = !this.peerReviewInfo;
  }
  toggleMetaDataInfo(){
    this.metadataInfo = !this.metadataInfo;
  }
  toggleEmailDisclaimerlInfo(){
    this.emailDisclaimerlInfo = !this.emailDisclaimerlInfo;
  }

  toggleAutoResponseInfo(){
    this.autoResponseInfo = !this.autoResponseInfo;
  }

  toggleEntitlementInfo(){
    this.entitlementInfo = !this.entitlementInfo;
  }

  setActiveGroupOption(e){
    this.autoResponseEdit=true;
    this.activeGroupOption = e.title;
    if(e.title === 'Client Category'){
      setTimeout(() => { // Use timeout to let the grid initialize
        if (this.clientCategoryDataGridApi && typeof this.clientCategoryDataGridApi.getDisplayedRowCount === 'function') {
          const currentRowCount = this.clientCategoryDataGridApi.getDisplayedRowCount();
          if (currentRowCount === 0) {
            this.onAddCustomCategory();
            this.onAddCustomCategory();
          } else if (currentRowCount === 1) {
            this.onAddCustomCategory();
          }
        }
      }, 0);
    }
    if(e.title === 'Automated Response'){
      this.initAutoResponseContent()
    }
  }
  // To store selected non-working days

  getDaySelection($event,_day){
    if(!_day.checked){
      this.selectedWeekelyOff.push(_day.value)
    }else{
      const index = this.selectedWeekelyOff.indexOf(_day.value);
      if (index !== -1) {
        this.selectedWeekelyOff.splice(index, 1);
      }
    }
    this.weekelyOff.map((_dayName)=>{
      if(_dayName.label === _day.label){
        _dayName.checked = !_dayName.checked
      }
    })


  }
  changeExpand(){
    this.isExpanded = !this.isExpanded;
  }

  @HostListener('dragover', ['$event'])
  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = true;  // Add this property to your component
  }

  @HostListener('dragleave', ['$event'])
  onDragLeave(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = false;
  }
  editAutoResponse(){
    this.autoResponseEdit = !this.autoResponseEdit;
  }
  removePlaceholders(text: string, placeholders: string[]): string {
    // Create a regex pattern to match placeholders inside square brackets
    const pattern = `\\[([^\\]]*\\b(?:${placeholders.join('|')})\\b[^\\]]*)\\]`;
    const regex = new RegExp(pattern, 'g');

    // Replace the entire matched content inside square brackets if it contains any of the placeholders
    return text.replace(regex, (match, content) => {
      // Remove only the specified placeholders from within the brackets
      const cleanedContent = content
        .split(' ')
        .filter(word => !placeholders.includes(word))
        .join(' ');

      // If nothing remains inside the brackets after cleaning, remove the brackets too
      return cleanedContent ? `[${cleanedContent}]` : '';
    });
  }
  addPlaceholdersIndividually(text: string, placeholders: string[]): string {
    if (placeholders.length === 0) return text;

    // Wrap each placeholder in square brackets and join with space
    const placeholderTexts = placeholders.map(p => `[${p}]`).join(' ');

    // Append placeholders at the end of the text
    return text.trim() + " " + placeholderTexts;
  }
  autoResponseCheckboxChange() {
    let updatedResponse = this.defaultAutoResponse;

    // Remove assigned user info if not included
    if (!this.includeAssignedUserInfo) {
      updatedResponse = updatedResponse.replace(
        /Your mail has been assigned to&nbsp;\s*<span style="box-sizing: border-box; font-weight: bolder;">\[user_firstname user_lastname\]<\/span>&nbsp;for resolution.&nbsp;/,
        ''
      );
    }
    // Remove user contact info if not included
    if (!this.includeUserContactInfo) {
      updatedResponse = updatedResponse.replace(
        /<span style="box-sizing: border-box; font-weight: bolder;">\[user_firstname\]<\/span>&nbsp;can be contacted on&nbsp;\s*<span style="box-sizing: border-box; font-weight: bolder;">\[user_contact_number\]<\/span>\.\s*/,
        ''
      );
    }

    // Remove manager contact info block if not included
    if (!this.includeManagerContactInfo) {
      updatedResponse = updatedResponse.replace(
        /<p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 1rem; color: #7e819b; font-family: OpenSans; font-size: 14px; font-weight: bold;">[\s\S]*?\[manager_email_address\][\s\S]*?<\/p>/,
        ''
      );
    }

    this.autoResponse = updatedResponse;
  }
}
